<template>
  <div class="intell-box intell-box_1">
    <div class="intell-left" ref="intellLeft">
      <div class="c-header patient-header">
        <div>
          <i style="font-size:24px;margin-right:10px;" class="iconfont icon-huanzhexinxi"></i>
          <span style="white-space: nowrap;" id="fontF">患者信息</span>
        </div>
        <div style="display:flex;align-items:center;flex:1;">
          <button class="btn btn_newpatient" @click="newPatient" style="margin-left:10px; margin-right:5px;width:120px;">新建</button>
          <i class="iconfont icon-zuidahua patient-max-btn" @click="showPatientFormMaxDialog = true" title="最大化" style="margin-left:auto;"></i>
        </div>
      </div>
      <div calss="intell-left-content" style="height:calc(100% - 42px);overflow-y:auto">
        <div class="patient-info">
          <div class="i-content">
            <el-form
              :model="form"
              ref="form"
              status-icon
              :rules="patientRules"
              size="mini"
              label-width="80px"
              label-position="left"
            >
              <el-form-item prop="id_in_hospital">
                <span slot="label">ID<span style="color:red;">**</span></span>
                <el-autocomplete
                  ref="idInput"
                  v-model="form.id_in_hospital"
                  :fetch-suggestions="querySearchId"
                  :trigger-on-focus="false"
                  :disabled="patient_id_disabled || readonly"
                  placeholder="请输入ID"
                  @select="handleSelectId"
                  style="width:85%;"
                  @blur="patientForm"
                  @input="form.id_in_hospital = form.id_in_hospital.replace(/[\u4e00-\u9fa5]/g, '')"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item prop="name">
                <span slot="label">姓 名<span style="color:red;">**</span></span>
                <el-autocomplete
                  :disabled="readonly"
                  popper-class="my-autocomplete"
                  v-model="form.name"
                  :fetch-suggestions="querySearch"
                  :trigger-on-focus="false"
                  placeholder="请输入姓名"
                  @select="handleSelect"
                  style="width:85%;"
                  @blur="patientForm"
                  ref="formName"
                  @input="form.name = form.name.replace(/\d/g, '')"
                >
                  <template slot-scope="{item}" @click="chooseExistPatient" style="width: 500px">
                    <span class="name">{{item.name}}， ID: </span>
                    <span class="phone">{{item.id_in_hospital}}</span>
                    <!-- <div class="address">{{item.address}}</div> -->
                  </template>
                </el-autocomplete>
              </el-form-item>
              <div class="patient-wrapper">
                <div class="sex-con">
                  <div class="label" style="margin-right: 25%;">性别<span style="color:red;">**</span></div>
                  <div>
                    <el-radio-group
                      :disabled="readonly"
                      change="changeGender"
                      v-model="form.gender"
                      size="mini"
                      style="width:90px;margin-left:16%;height:30px;"
                      @change="patientForm"
                    >
                      <el-radio-button label="男"></el-radio-button>
                      <el-radio-button label="女"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="race-con">
                  <div class="label" style="margin-right: 10%;">年龄<span style="color:red;">*</span></div>
                  <div id="input-box_1">
                    <el-input
                      :disabled="readonly"
                      v-model="form.age"
                      placeholder=""
                      type
                      size="mini"
                      maxlength="3"
                      style="width:54%;"
                      @input="form.age = form.age.replace(/[^\d]/g, '')"
                      @blur="patientForm"
                    ></el-input>
                    <!--<div style="margin-left:6px;font-size: 14px;line-height: 28px;">岁</div>-->
                  </div>
                </div>
              </div>
              <el-form-item prop="birthday" style="margin-top:10px;">
                <span slot="label">生日<span style="color:red;">*</span></span>
                <el-date-picker
                  :disabled="readonly"
                  v-model="form.birthday"
                  align="right"
                  type="date"
                  :clearable="false"
                  placeholder="年龄或生日选填一项"
                  value-format="yyyy-MM-dd"
                  default-value="1980-01-01"
                  size="small"
                  style="width:85%;"
                  @blur="patientForm"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="手机号码" prop="phone">
                <el-input
                  :disabled="readonly"
                  v-model="form.phone"
                  placeholder="请输入手机号"
                  type
                  maxlength="11"
                  style="width:85%;"
                  @input="form.phone = form.phone.replace(/[^\d]/g, '')"
                  @blur="patientForm"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证">
                <el-input
                  :disabled="readonly"
                  v-model="form.idCardNumber"
                  placeholder="请输入身份证号"
                  type
                  style="width:85%;"
                  @blur="patientForm"
                  maxlength="18"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="民族" prop="race">
                <el-select
                  v-model="form.race"
                  placeholder="请选择民族"
                  size="mini"
                  style="width:85%;"
                  :disabled="readonly"
                  @blur="patientForm"
                >
                  <el-option
                    v-for="item in races"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item> -->


              <el-form-item label="皮肤类型"  prop="skin_type">
                <el-select
                  v-model="form.skin_type"
                  placeholder="请选择皮肤类型"
                  size="small"
                  style="width:85%;"
                  :disabled="readonly"
                  @blur="patientForm"
                >
                  <el-option
                    v-for="item in skinOpsType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="备注">
                <el-input
                  v-model="form.note"
                  style="width: 100%;"
                  placeholder="不得超过64个字"
                  :disabled="readonly"
                  type="textarea"
                  @blur="patientForm"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>

              <el-form-item label="肤色" v-if="!patientMore" prop="skin_color">
                <el-select
                  v-model="form.skin_color"
                  placeholder="请选择肤色"
                  size="small"
                  style="width:85%;"
                  :disabled="readonly"
                  @blur="patientForm"
                >
                  <el-option
                    v-for="item in skinOps"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="地址" v-if="!patientMore">
                <el-input
                  :disabled="readonly"
                  v-model="form.address"
                  placeholder="请输入地址"
                  type
                  style="width:85%;"
                  @blur="patientForm"
                ></el-input>
              </el-form-item>
              <el-form-item label="籍贯" v-if="!patientMore">
                <el-input
                  :disabled="readonly"
                  v-model="form.nativePlace"
                  placeholder="请输入籍贯"
                  type
                  style="width:85%;"
                  @blur="patientForm"
                ></el-input>
              </el-form-item>
              <el-form-item label="国别" v-if="!patientMore">
                <el-input
                  :disabled="readonly"
                  v-model="form.country"
                  placeholder="请输入国别"
                  type
                  style="width:85%;"
                  @blur="patientForm"
                ></el-input>
              </el-form-item>
              <el-form-item label="职业" v-if="!patientMore">
                <el-input
                  :disabled="readonly"
                  v-model="form.profession"
                  placeholder="请输入职业"
                  type
                  style="width:85%;"
                  v-if="!patientMore"
                  @blur="patientForm"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮件" v-if="!patientMore" prop="email">
                <el-input
                  :disabled="readonly"
                  v-model="form.email"
                  placeholder="请输入电子邮件"
                  type
                  style="width:85%;"
                  @blur="patientForm"
                ></el-input>
              </el-form-item>
            </el-form>
            <!-- <div class="moreBtn" v-if="patientMore" style="width:88%;margin-bottom:10px;">
              <div class="show-more-text" @click="showPatientMore('show')">更多</div>
              <div class="iconfont show-more-btn" @click="showPatientMore('show')">&#xe7fe;</div>
            </div> -->
          </div>
        </div>
        <!-- 患者信息最大化对话框 -->
        <el-dialog
          title="患者信息"
          :visible.sync="showPatientFormMaxDialog"
          width="1050px"
          :close-on-click-modal="false"
          class="dialog patient-max-dialog"
          append-to-body
        >
          <div class="navBorder"></div>
          <el-form
            :model="form"
            status-icon
            :rules="patientRules"
            size="medium"
            label-width="100px"
            label-position="left"
            class="patient-max-form"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item prop="name" :class="{'field-filled': form.name}">
                  <span slot="label">姓名<span style="color:red;">**</span></span>
                  <el-autocomplete
                    :disabled="readonly"
                    popper-class="my-autocomplete"
                    v-model="form.name"
                    :fetch-suggestions="querySearch"
                    :trigger-on-focus="false"
                    placeholder="请输入姓名"
                    @select="handleSelect"
                    style="width:100%;"
                    @blur="patientForm"
                    @input="form.name = form.name.replace(/\d/g, '')"
                  >
                    <template slot-scope="{item}">
                      <span class="name">{{item.name}}， ID: </span>
                      <span class="phone">{{item.id_in_hospital}}</span>
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="id_in_hospital" :class="{'field-filled': form.id_in_hospital}">
                  <span slot="label">ID<span style="color:red;">**</span></span>
                  <el-autocomplete
                    v-model="form.id_in_hospital"
                    :fetch-suggestions="querySearchId"
                    :trigger-on-focus="false"
                    :disabled="patient_id_disabled || readonly"
                    placeholder="请输入ID"
                    @select="handleSelectId"
                    style="width:100%;"
                    @blur="patientForm"
                    @input="form.id_in_hospital = form.id_in_hospital.replace(/[\u4e00-\u9fa5]/g, '')"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <span slot="label">性别<span style="color:red;">**</span></span>
                  <el-radio-group
                    :disabled="readonly"
                    v-model="form.gender"
                    @change="patientForm"
                  >
                    <el-radio-button label="男"></el-radio-button>
                    <el-radio-button label="女"></el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item prop="birthday" :class="{'field-filled': form.birthday}">
                  <span slot="label">出生日期<span style="color:red;">*</span></span>
                  <el-date-picker
                    :disabled="readonly"
                    v-model="form.birthday"
                    type="date"
                    :clearable="false"
                    placeholder="年龄或生日选填一项"
                    value-format="yyyy-MM-dd"
                    default-value="1980-01-01"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :class="{'field-filled': form.age}">
                  <span slot="label">年龄<span style="color:red;">*</span></span>
                  <el-input
                    :disabled="readonly"
                    v-model="form.age"
                    maxlength="3"
                    style="width:100%;"
                    @input="form.age = form.age.replace(/[^\d]/g, '')"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号码" prop="phone" :class="{'field-filled': form.phone}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.phone"
                    placeholder="请输入手机号"
                    maxlength="11"
                    style="width:100%;"
                    @input="form.phone = form.phone.replace(/[^\d]/g, '')"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="手机号码2" :class="{'field-filled': form.phone2}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.phone2"
                    maxlength="11"
                    style="width:100%;"
                    @input="form.phone2 = form.phone2.replace(/[^\d]/g, '')"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身高(cm)" :class="{'field-filled': form.height}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.height"
                    type="number"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="体重(kg)" :class="{'field-filled': form.weight}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.weight"
                    type="number"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="皮肤类型" prop="skin_type" :class="{'field-filled': form.skin_type}">
                  <el-select
                    v-model="form.skin_type"
                    placeholder="请选择皮肤类型"
                    style="width:100%;"
                    :disabled="readonly"
                    @blur="patientForm"
                  >
                    <el-option
                      v-for="item in skinOpsType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="肤色" prop="skin_color" :class="{'field-filled': form.skin_color}">
                  <el-select
                    v-model="form.skin_color"
                    placeholder="请选择肤色"
                    style="width:100%;"
                    :disabled="readonly"
                    @blur="patientForm"
                  >
                    <el-option
                      v-for="item in skinOps"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份证" :class="{'field-filled': form.idCardNumber}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.idCardNumber"
                    placeholder="请输入身份证号"
                    maxlength="18"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="地址" :class="{'field-filled': form.address}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.address"
                    placeholder="请输入地址"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="职业" :class="{'field-filled': form.profession}">
                  <el-select
                    v-model="form.profession"
                    placeholder="请选择职业"
                    style="width:100%;"
                    :disabled="readonly"
                    filterable
                    allow-create
                    default-first-option
                    @blur="patientForm"
                  >
                    <el-option
                      v-for="item in professionOpts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="文化程度" :class="{'field-filled': form.education}">
                  <el-select
                    v-model="form.education"
                    placeholder="请选择文化程度"
                    style="width:100%;"
                    :disabled="readonly"
                    @blur="patientForm"
                  >
                    <el-option
                      v-for="item in educationOpts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否吸烟" :class="{'field-filled': form.smoking}">
                  <el-select
                    v-model="form.smoking"
                    placeholder="请选择"
                    style="width:100%;"
                    :disabled="readonly"
                    @blur="patientForm"
                  >
                    <el-option
                      v-for="item in smokingOpts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="是否饮酒" :class="{'field-filled': form.drinking}">
                  <el-select
                    v-model="form.drinking"
                    placeholder="请选择"
                    style="width:100%;"
                    :disabled="readonly"
                    @blur="patientForm"
                  >
                    <el-option
                      v-for="item in drinkingOpts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="饮食习惯" :class="{'field-filled': form.dietHabitArr}">
                  <el-select
                    v-model="form.dietHabitArr"
                    placeholder="请选择"
                    style="width:100%;"
                    :disabled="readonly"
                    multiple
                    @change="handleDietHabitChange"
                    @blur="patientForm"
                  >
                    <el-option
                      v-for="item in dietHabitOpts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="籍贯" :class="{'field-filled': form.nativePlace}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.nativePlace"
                    placeholder="请输入籍贯"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="民族" prop="race" :class="{'field-filled': form.race}">
                  <el-select
                    v-model="form.race"
                    placeholder="请选择民族"
                    style="width:100%;"
                    :disabled="readonly"
                    @blur="patientForm"
                  >
                    <el-option
                      v-for="item in races"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电子邮件" prop="email" :class="{'field-filled': form.email}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.email"
                    placeholder="请输入电子邮件"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="国别" :class="{'field-filled': form.country}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.country"
                    placeholder="请输入国别"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="备注" :class="{'field-filled': form.note}">
                  <el-input
                    :disabled="readonly"
                    v-model="form.note"
                    type="textarea"
                    :rows="2"
                    style="width:100%;"
                    @blur="patientForm"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-dialog>
        <!-- 检查信息最大化对话框 -->
        <el-dialog
          title="病历信息"
          :visible.sync="showCheckFormMaxDialog"
          width="1050px"
          :close-on-click-modal="false"
          class="dialog patient-max-dialog"
          append-to-body
        >
          <div class="navBorder"></div>
          <el-form
            :model="form2"
            status-icon
            :rules="checkRules"
            size="medium"
            label-width="100px"
            label-position="left"
            class="check-max-form"
            v-if="isShowStateIcon"
          >
            <el-row :gutter="20">
              <el-col :span="24">
                <div style="position: relative" @mouseleave="hideCheckPositionMax">
                  <el-form-item>
                    <span slot="label">检查部位<span style="color:red;">*</span></span>
                    <el-input
                      style="width: 100%;"
                      :readonly="fromDetailDiagnose"
                      placeholder="----添加检查部位----"
                      @click.native="showCheckPositionMax"
                    ></el-input>
                    <div class="topLevelCon check-max-top-level" v-if="checkoverviewMax">
                      <div
                        class="topLevelItem"
                        v-for="(item, index) in options"
                        :key="index"
                        @mouseover="activeTopLevel(index)"
                        v-bind:style="{background: index === topLevelIndex ? '#3574B1' : '#9EC9E2',color: index === topLevelIndex ? 'white' : 'black'}"
                      >
                        {{item}}
                        <template v-if="index < options.length - 3">
                          <div
                            class="secondLevelCon"
                            v-if="index === topLevelIndex"
                            v-bind:style="{'top': 0 + 'px'}"
                          >
                            <div
                              class="secondLevelItem"
                              v-for="(innerItem, index2) in figureObj[item]"
                              :key="index2"
                              @mouseover="activeSecondLevel($event,index2)"
                              v-bind:style="{background: index2 === secondLevelIndex ? '#3574B1' : '#9EC9E2',color: index2 === secondLevelIndex ? 'white' : 'black'}"
                              @click="ensureFigure(item,innerItem)"
                            >{{innerItem}}
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            class="secondLevelCon"
                            v-if="index === topLevelIndex"
                            v-bind:style="{'bottom': -1 + 'px'}"
                          >
                            <div
                              class="secondLevelItem"
                              v-for="(innerItem, index2) in figureObj[item]"
                              :key="index2"
                              @mouseover="activeSecondLevel($event,index2)"
                              v-bind:style="{background: index2 === secondLevelIndex ? '#3574B1' : '#9EC9E2',color: index2 === secondLevelIndex ? 'white' : 'black'}"
                              @click="ensureFigure(item,innerItem)"
                            >{{innerItem}}
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </el-form-item>
                  <div class="choosedFigureCon" v-if="choosedPosition.length > 0">
                    <div
                      class="choosedFigureItem"
                      id="fontM"
                      v-for="(item, index) in choosedPosition"
                      :key="index"
                      v-bind:style="{background: choosedPositionIndex === index ? '#3574B1' : '#9EC9E2',color: choosedPositionIndex === index ? 'white' : 'black'}"
                      @click="moveOnChoosedPosition(index)"
                    >
                      {{item.overviewPosition}}-{{item.detailPosition}}
                      <div
                        id="icon-close-1"
                        class="el-icon-close"
                        style="cursor: pointer"
                        @click="deleteThePosition($event,item.overviewPosition,item.detailPosition,index)"
                      ></div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="申请医生" prop="applicant" :class="{'field-filled': form2.applicant}">
                  <el-autocomplete
                    class="inline-input"
                    v-model="form2.applicant"
                    :fetch-suggestions="queryApplyDoctors"
                    placeholder="请输入申请医生"
                    @select="selectedDoctor"
                    @blur="checkDiagnosis"
                    style="width: 100%;"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="申请单位" prop="applicant_unit" :class="{'field-filled': form2.applicant_unit}">
                  <el-autocomplete
                    class="inline-input"
                    v-model="form2.applicant_unit"
                    :fetch-suggestions="queryApplyUnit"
                    placeholder="请输入检查单位"
                    @select="selectedApplyUnit"
                    @blur="checkDiagnosis"
                    style="width: 100%;"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检查医生" prop="review_doctor" :class="{'field-filled': form2.review_doctor}">
                  <el-autocomplete
                    class="inline-input"
                    v-model="form2.review_doctor"
                    :fetch-suggestions="queryReviewDoctor"
                    placeholder="请输入检查医生"
                    @select="selectedReviewDoctor"
                    @blur="checkDiagnosis"
                    style="width: 100%;"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="检查单位" prop="unit" :class="{'field-filled': form2.unit}">
                  <el-autocomplete
                    class="inline-input"
                    v-model="form2.unit"
                    :fetch-suggestions="queryCheckUnit"
                    placeholder="请输入检查单位"
                    @select="selectedCheckUnit"
                    @blur="checkDiagnosis"
                    style="width: 100%;"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检查费用" prop="fee" :class="{'field-filled': form2.fee}">
                  <el-autocomplete
                    class="inline-input"
                    v-model="form2.fee"
                    :fetch-suggestions="queryFee"
                    placeholder="请输入检查费用"
                    @select="selectedCheckFee"
                    @blur="checkDiagnosis"
                    style="width: 100%;"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="门诊诊断" prop="initial_conclusion" :class="{'field-filled': form2.initial_conclusion}">
                  <el-input
                    v-model="form2.initial_conclusion"
                    style="width: 100%;"
                    placeholder="不得超过512个字"
                    :readonly="fromDetailDiagnose"
                    type="textarea"
                    @blur="addDiagnosis"
                    :maxlength="textAreaMaxLen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="主诉" :class="{'field-filled': form2.complaint}">
                  <el-input
                    v-model="form2.complaint"
                    style="width: 100%;"
                    placeholder="不得超过512个字"
                    :readonly="fromDetailDiagnose"
                    type="textarea"
                    @blur="addDiagnosis"
                    :maxlength="textAreaMaxLen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="现病史" :class="{'field-filled': form2.disease_history_present}">
                  <el-input
                    v-model="form2.disease_history_present"
                    style="width: 100%;"
                    placeholder="不得超过512个字"
                    :readonly="fromDetailDiagnose"
                    type="textarea"
                    @blur="addDiagnosis"
                    :maxlength="textAreaMaxLen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="既往史" :class="{'field-filled': form2.disease_history_before}">
                  <el-input
                    v-model="form2.disease_history_before"
                    style="width: 100%;"
                    placeholder="不得超过512个字"
                    :readonly="fromDetailDiagnose"
                    type="textarea"
                    @blur="addDiagnosis"
                    :maxlength="textAreaMaxLen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="体格检查" :class="{'field-filled': form2.physical_examination}">
                  <el-input
                    v-model="form2.physical_examination"
                    style="width: 100%;"
                    placeholder="不得超过512个字"
                    :readonly="fromDetailDiagnose"
                    type="textarea"
                    @blur="addDiagnosis"
                    :maxlength="textAreaMaxLen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="过敏史" :class="{'field-filled': form2.allergy_history}">
                  <el-input
                    v-model="form2.allergy_history"
                    style="width: 100%;"
                    placeholder="不得超过512个字"
                    :readonly="fromDetailDiagnose"
                    type="textarea"
                    @blur="addDiagnosis"
                    :maxlength="textAreaMaxLen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="实验室" :class="{'field-filled': form2.lab}">
                  <el-input
                    v-model="form2.lab"
                    style="width: 100%;"
                    type="textarea"
                    placeholder="不得超过512个字"
                    @blur="addDiagnosis"
                    :maxlength="textAreaMaxLen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="家族史" :class="{'field-filled': form2.disease_history_family}">
                  <el-input
                    v-model="form2.disease_history_family"
                    style="width: 100%;"
                    placeholder="不得超过512个字"
                    :readonly="fromDetailDiagnose"
                    type="textarea"
                    @blur="addDiagnosis"
                    :maxlength="textAreaMaxLen"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-dialog>
        <!--检查信息相关html-->
        <div class="check-info">
          <div class="c-header" style="width: 91%;display:flex;justify-content:space-between;align-items:center;">
            <div>
              <i style="font-size:24px;margin-right:10px;" class="iconfont icon-jianchaxinxi"></i>
              <span id="fontF">病历信息</span>
            </div>
            <i class="iconfont icon-zuidahua check-max-btn" @click="showCheckFormMaxDialog = true" title="最大化"></i>
          </div>
          <div class="c-content">
            <el-form
              :model="form2"
              size="mini"
              status-icon
              :rules="checkRules"
              style="width:95%"
              v-if="isShowStateIcon"
              label-width="80px"
              label-position="left"
            >
              <div style="position: relative" @mouseleave="hideCheckPosition">
                <el-form-item>
                  <span slot="label">检查部位<span style="color:red;">*</span></span>
                  <!-- @mouseover.native="showCheckPosition" @mouseleave.native="hideCheckPostion" -->
                  <el-input
                    style="width: 100%;"
                    :readonly="fromDetailDiagnose"
                    placeholder="----添加检查部位----"
                    @click.native="showCheckPosition"
                  ></el-input>
                  <div class="topLevelCon" v-if="checkoverview">
                    <div
                      class="topLevelItem"
                      v-for="(item, index) in options"
                      :key="index"
                      @mouseover="activeTopLevel(index)"
                      v-bind:style="{background: index === topLevelIndex ? '#3574B1' : '#9EC9E2',color: index === topLevelIndex ? 'white' : 'black'}"
                    >
                      {{item}}
                      <template v-if="index < options.length - 3">
                        <div
                          class="secondLevelCon"
                          v-if="index === topLevelIndex"
                          v-bind:style="{'top': 0 + 'px'}"
                        >
                          <div
                            class="secondLevelItem"
                            v-for="(innerItem, index2) in figureObj[item]"
                            :key="index2"
                            @mouseover="activeSecondLevel($event,index2)"
                            v-bind:style="{background: index2 === secondLevelIndex ? '#3574B1' : '#9EC9E2',color: index2 === secondLevelIndex ? 'white' : 'black'}"
                            @click="ensureFigure(item,innerItem)"
                          >{{innerItem}}
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="secondLevelCon"
                          v-if="index === topLevelIndex"
                          v-bind:style="{'bottom': -1 + 'px'}"
                        >
                          <div
                            class="secondLevelItem"
                            v-for="(innerItem, index2) in figureObj[item]"
                            :key="index2"
                            @mouseover="activeSecondLevel($event,index2)"
                            v-bind:style="{background: index2 === secondLevelIndex ? '#3574B1' : '#9EC9E2',color: index2 === secondLevelIndex ? 'white' : 'black'}"
                            @click="ensureFigure(item,innerItem)"
                          >{{innerItem}}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </el-form-item>
                <div class="choosedFigureCon" v-if="choosedPosition.length > 0">
                  <div
                    class="choosedFigureItem"
                    id="fontM"
                    v-for="(item, index) in choosedPosition"
                    :key="index"
                    v-bind:style="{background: choosedPositionIndex === index ? '#3574B1' : '#9EC9E2',color: choosedPositionIndex === index ? 'white' : 'black'}"
                    @click="moveOnChoosedPosition(index)"
                  >
                    {{item.overviewPosition}}-{{item.detailPosition}}
                    <div
                      id="icon-close-1"
                      class="el-icon-close"
                      style="cursor: pointer"
                      @click="deleteThePosition($event,item.overviewPosition,item.detailPosition,index)"
                    ></div>
                  </div>
                </div>
              </div>
              <el-form-item label="申请医生" prop="applicant">
                <el-autocomplete
                  class="inline-input"
                  v-model="form2.applicant"
                  :fetch-suggestions="queryApplyDoctors"
                  placeholder="请输入申请医生"
                  @select="selectedDoctor"
                  @blur="checkDiagnosis"
                  style="width: 100%;"
                ></el-autocomplete>
              </el-form-item>

              <!-- 此处的“检查医生”其背后数据为审核医生，修改为检查医生是为了用户可以在报告中显示指定的“检查医生”姓名 -->
              <el-form-item label="检查医生" prop="review_doctor">
                <el-autocomplete
                  class="inline-input"
                  v-model="form2.review_doctor"
                  :fetch-suggestions="queryReviewDoctor"
                  placeholder="请输入检查医生"
                  @select="selectedReviewDoctor"
                  @blur="checkDiagnosis"
                  style="width: 100%;"
                ></el-autocomplete>
              </el-form-item>

              <!--<el-form-item label="检查编号*" prop="id_in_hospital">
<el-input v-model="form2.id_in_hospital" style="width: 100%;" :disabled="hospital_id_disabled"
          :readonly="fromDetailDiagnose" placeholder="请输入检查编号" @blur="checkDiagnosis"></el-input>
</el-form-item>-->

              <el-form-item label="门诊诊断" prop="initial_conclusion">
                <el-input
                  v-model="form2.initial_conclusion"
                  style="width: 100%;"
                  placeholder="不得超过512个字"
                  :readonly="fromDetailDiagnose"
                  type="textarea"
                  @blur="addDiagnosis"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>
              <el-form-item label="主诉">
                <el-input
                  v-model="form2.complaint"
                  style="width: 100%;"
                  placeholder="不得超过512个字"
                  :readonly="fromDetailDiagnose"
                  type="textarea"
                  @blur="addDiagnosis"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>
              <el-form-item label="现病史">
                <el-input
                  v-model="form2.disease_history_present"
                  style="width: 100%;"
                  placeholder="不得超过512个字"
                  :readonly="fromDetailDiagnose"
                  type="textarea"
                  @blur="addDiagnosis"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>
              <el-form-item label="既往史" >
                <el-input
                  v-model="form2.disease_history_before"
                  style="width: 100%;"
                  placeholder="不得超过512个字"
                  :readonly="fromDetailDiagnose"
                  type="textarea"
                  @blur="addDiagnosis"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>
              <el-form-item label="体格检查">
                <el-input
                  v-model="form2.physical_examination"
                  style="width: 100%;"
                  placeholder="不得超过512个字"
                  :readonly="fromDetailDiagnose"
                  type="textarea"
                  @blur="addDiagnosis"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>
              <el-form-item label="过敏史" v-if="!checkMore">
                <el-input
                  v-model="form2.allergy_history"
                  style="width: 100%;"
                  placeholder="不得超过512个字"
                  :readonly="fromDetailDiagnose"
                  type="textarea"
                  @blur="addDiagnosis"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>
              <el-form-item label="实验室" v-if="!checkMore">
                <el-input
                  v-model="form2.lab"
                  style="width: 100%;"
                  type="textarea"
                  placeholder="不得超过512个字"
                  @blur="addDiagnosis"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>
              <el-form-item label="家族史" v-if="!checkMore">
                <el-input
                  v-model="form2.disease_history_family"
                  style="width: 100%;"
                  placeholder="不得超过512个字"
                  :readonly="fromDetailDiagnose"
                  type="textarea"
                  @blur="addDiagnosis"
                  :maxlength="textAreaMaxLen"
                ></el-input>
              </el-form-item>
              <el-form-item label="申请单位" prop="applicant_unit" v-if="!checkMore">
                <el-autocomplete
                  class="inline-input"
                  v-model="form2.applicant_unit"
                  :fetch-suggestions="queryApplyUnit"
                  placeholder="请输入检查单位"
                  @select="selectedApplyUnit"
                  @blur="checkDiagnosis"
                  style="width: 100%;"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item label="检查单位" prop="unit" v-if="!checkMore">
                <el-autocomplete
                  class="inline-input"
                  v-model="form2.unit"
                  :fetch-suggestions="queryCheckUnit"
                  placeholder="请输入检查单位"
                  @select="selectedCheckUnit"
                  @blur="checkDiagnosis"
                  style="width: 100%;"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item label="检查费用" prop="fee"  v-if="!checkMore">
                <el-autocomplete
                  class="inline-input"
                  v-model="form2.fee"
                  :fetch-suggestions="queryFee"
                  placeholder="请输入检查费用"
                  @select="selectedCheckFee"
                  @blur="checkDiagnosis"
                  style="width: 100%;"
                ></el-autocomplete>
              </el-form-item>
            </el-form>
            <!-- <div class="moreBtn" v-if="checkMore" style="width:94%;height: 24px">
              <div class="show-more-text" @click="showCheckMore('show')">更多</div>
              <div class="iconfont show-more-btn" @click="showCheckMore('show')">&#xe7fe;</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="intell-right">
      <div class="left-content">
        <div class="intell-r-t">
          <div class="img-l" @contextmenu.prevent="">
            <div class="i-header" style="margin:0;width:100%;">
              <div style="display:flex;align-items:center;margin-top:0.5%">
                <i style="font-size:1.5rem;margin-right:10px;" class="iconfont icon-xiangji"></i>
                <span id="fontF">影像采集</span>
              </div>
            </div>
            <div style="height:97%;overflow-y:auto;">
              <!--影像采集-->
              <div class="CTetc-con">

                <!--各模态影像的标签栏-->
                <!-- v-edit: 如果${item.text2} 不在诊断影像模块使用权限 intellModel:[]（'edit_DTT', 'edit_PFJ', 'edit_CT', 'edit_BC', 'edit_BL'）中，
                就将v-bind替换为'display:none' -->                    
                <div class="top-nav">
                  <div
                    v-for="(item,index) in tags"
                    :key="index"
                    v-edit="[`${item.text2}`]"  
                    class="option-item"
                    @click="activeOption(item.text,index)"
                    v-bind:style="{'backgroundColor': item.checked ? item.activecolor : '','color': item.checked ? item.color : '','font-weight': item.checked ? 'bolder': '','font-size': item.checked ? '20px': ''}"
                  >
                    <span>{{item.text}}</span>
                  </div>
                </div>

                <!--tags 不同标签下的图片处理及镜下所见-->
                <collection-type
                  ref="collectionType"
                  v-if="reloadCollection"
                  :general="isGeneral"
                  :ct="isCT"
                  :bc="isBC"
                  :sk="skin"
                  :bingli="bl"
                  @saveTop5="saveTop5"
                  @saveConclusion="saveConclusion(false, '', 'yes')"
                  :diseaseid="diseaseid"
                  :diagnoseResult="diagnoseResult"
                  :diagnoseType="diagnoseType"
                  :template="template"
                  :wordBook="wordbook"
                  :btnEnabled="fromDetailDiagnose"
                  :disableIntell="disableIntell"
                  :diagnosis_id="diagnosisId"
                  v-on:message="getCollectionMessage"
                  :ImgArr="imgList"
                  :overviewResult="overview_result"
                  :position="activePosition"
                  :isNewDiagnose="isNewDiagnose"
                  @refreshImages="refreshImages"
                  :reportText="reportText"
                  @showThisPic="showPic"
                  @closeShowSuggestionTemplate="closeShowSuggestionTemplate"
                  @showThumbnailImage="showThumbnailImage"
                ></collection-type>
              </div>

              <!--诊断结果及建议及报告-->
              <div class="row-con" id="printContent">
                <!--诊断结果-->
                <!-- 如果建议区不显示，那么诊断结果区自动变宽，flex-grow：1 无效果-->
                <div @mouseleave="hiddentRemarkTemplate" class="imgRes">
                  <div class="imgResLine" style="margin-bottom: 2%;">
                    <!-- 如果当前选项是超声，将影像诊断改为”考虑“ ， by steven -->
                    <div v-if="this.isBC==true"    style="margin-right: 10px;" class="mirrorText" id="fontM">考虑:</div>
                    <div v-else style="margin-right: 10px;" class="mirrorText" id="fontM">影像诊断:</div>
                    <el-autocomplete
                      id="diagnose-result-input"
                      class="inline-input"
                      v-model="diagnoseResult"
                      :fetch-suggestions="queryDisease"
                      placeholder="----诊断结果----"
                      :trigger-on-focus="false"
                      @select="selectedDisease"
                      @blur="saveConclusion(false, '', 'yes')"
                      @focus="selectedDiagnose = false"
                      size="small"
                      style="width: 80%;"
                    ></el-autocomplete>
                    <div
                      class="iconfont save-btn"
                      v-show="diagnoseType"
                      title="将诊断结果保存到自定义模板中"
                      @click.stop="addDiagnosisToMyTemplate"
                    >&#xe640;</div>
                  </div>
                  <div v-show="isShowRemarksTemplate && remarksTemplate.length"
                      class="autoComplate"
                      style="
                        position: absolute;
                        left: 1%;
                        top: 65%;
                        width: 47%;
                        height: 125px;
                      "
                   >
                    <ul style="height: 100%;overflow-y: auto;">
                      <li
                              class="item"
                              v-for="(item, index) in remarksTemplate"
                              :key="index"
                              @click="selectRemarksTemplate(item.value)"
                      >
                        <div class="item-text">{{item.value}}</div>
                        <div class="delete-box">
                          <div class="delete-ben iconfont"  @click.stop="deleteRemarksTemplate(index)">&#xe634;
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div @click.stop="closeAutoComplete" style="height: 100%;width: 100%">
                    <div class="imgResLine" style="height: 20%">
                      <div style="margin-right: 10px;padding-top: 4px;width: 100%" class="mirrorText" id="fontM">
                        <span style="float:left;">备注
                          <el-popover
                            placement="top-start"
                            title="帮助"
                            width="200"
                            trigger="hover"
                            content="此处输入的备注信息，可以在【高级搜索】-【影像检查】-【就诊记录】中进行检索"
                          >
                            <i slot="reference" class="iconfont icon-bangzhu popTips" ></i>
                          </el-popover>:
                        </span>
                        <div
                          class="iconfont"
                          title="保存备注模板"
                          style="float:right;right: 3px;top: -4px;font-size: 28px;cursor: pointer;"
                          @click.stop="handleSaveReportTemplate"
                        >&#xe640;</div>
                      </div>
                    </div>
                    <div @click="remarkHeadClick" style="height: 80%;width: 100%">
                      <textarea
                              placeholder
                              ref="remarkText"
                              autocomplete="off"
                              v-model="otherDescription"
                              style="
                              border: none;
                              height: 100%;
                              width: 100%;
                              resize: none;
                              font-size: 16px;
                              "
                              @focus="showReportTemplate"
                              @blur="modifyDoctorReport"
                      ></textarea>
                      <!--<div style="display: flex;flex-wrap: wrap;margin-top: 10px">
                        <div
                          style="padding: 3px 5px;background-color: #ebebeb;margin-right: 3px;cursor: default;margin-top: 2px;font-size: 15px;"
                          v-for="(item, index) in customTemplate"
                          @click="setOtherDescription(item)"
                        >{{item}}</div>
                      </div>-->
                    </div>
                  </div>
                </div>

                  <!-- 建议和报告打印区 -->
                  <!-- 打印报告的按钮靠右排列，justify-content:flex-end -->
                  <div @mouseleave="hiddentSuggestTemplate"
                    style="border-radius:10px;resize:none;width:100%;height:100%;font-size:15px;display:flex;box-sizing: border-box; justify-content:flex-end"
                  >
                    <!-- 建议区 -->
                    <!-- <div v-show="this.isGeneral||this.skin||this.bl"  -->
                    <div v-if="(this.isGeneral||this.skin||this.bl) == true"   
                        style="border-radius:10px;resize:none;flex:1;height:100%;box-sizing:border-box;border:1px solid #48a3c2;font-size:15px;display: flex;flex-direction: column;position: relative;"
                        @click.stop="closeAutoComplete"
                    >
                      <div v-show="isShowSuggestionTemplate && suggestionTemplate.length" class="autoComplate">
                        <ul style="height: 100%;overflow-y: auto;">
                          <li
                            class="item"
                            v-for="(item, index) in suggestionTemplate"
                            :key="index"
                            @click="selectSuggestionTemplate(item.value)"
                          >
                            <div class="item-text">{{item.value}}</div>
                            <div class="delete-box">
                              <div class="delete-ben iconfont"  @click.stop="deleteSuggestionTemplate(index)">&#xe634;
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      
                      <div
                        style="font-size: 16px;color:#61a2bf;display: flex;justify-content: space-between;margin-top:5px;margin-left: 5px;position: relative;"
                        @click="suggestionHeadClick"
                      >
                      <span>建议：</span>
                      <div
                        class="iconfont"
                        title="保存建议模板"
                        style="position: absolute;right: 3px;top: -4px;font-size: 28px;cursor: pointer;"
                        @click.stop="handleSaveSuggestionTemplate"
                      >&#xe640;</div>
                      </div>

                      <!-- 建议输入区 -->
                      <textarea
                        ref="suggestionInput"
                        autocomplete="off"
                        rows="5"
                        placeholder
                        v-model="advise"
                        @blur="saveSuggestion"
                        @focus="showSuggestionTemplate"
                        style="width: 100%;border: none;resize: none;flex: 1;box-sizing: border-box;padding: 5px;font-size: 16px;line-height: 20px;border-radius: 10px;"
                      ></textarea>
                      <!-- </div> -->
                    </div>

                    <!-- 报告区 -->
                    <div class="btns">
                      <div class="markAndGenerate">
                        <div class="collectBtn">
                          <button class="btn print-btn" @click="showPrint(false)" style="width:92px;font-size: 16px">打印报告
                          </button>
                          
                          <el-tooltip  content="打印报告的同时，生成或者更新云胶片。须正确填写患者手机号。" placement="right">
                            <el-checkbox style="width:100px; font-size:6px;" v-model="needGenOnlineReport"  v-acl="['gen_online_report']">生成/更新云胶片</el-checkbox>
                          </el-tooltip>

                          <button class="btn download-btn" @click="showPrint(true)" style="width:92px;font-size: 16px">下载报告
                          </button>
                          <button class="btn btn-btn" v-if="isCollection" style="width:92px;"
                                  @click="mark">
                            <img src="../assets/love_it.png" style="width:20px;height:20px;">
                          </button>
                          <button class="btn btn-btn" v-if="!isCollection" style="width:92px;"
                                  @click="mark">
                            <img
                              v-if="!isCollection"
                              src="../assets/love_w.png"
                              style="width:20px;height:20px;"
                            >
                          </button>
                          
                          <!-- <button class="btn btn_newpatient" @click="newDiagnose" style="width:92px;">新的诊断</button> -->
                        </div>
                      </div>
                    </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-knowledge" ref="intellRight" @contextmenu="prevent" @scroll="scrollLog">
      <div class="detailed-l" v-show="skin || isCT || isBC || bl">
        <div class="detailed-head">
          <img src="../assets/iconfont/files.svg" style="width:35px;height:auto;">
          <span v-show="skin">皮肤镜报告模板</span>
          <span v-show="isCT">CT报告模板</span>
          <span v-show="isBC">超声报告模板</span>
          <span v-show="bl">病理报告模板</span>
        </div>
        <div class="tree-content">
          <Tree
            ref="myTree"
            :diagnoseType="diagnoseType"
            @getContent="getContent"
            @cloneTemplate="cloneTemplate"
            :treeReload="treeReload"
            :scrollChange="scrollChange"
            @showMenu="showMenu"
          />
        </div>
      </div>
      <div class="history-tabel">
        <div class="head">
          <div class="iconfont">&#xe65d;</div>
          <div class="title">历史诊疗</div>
        </div>
        <el-table
          :data="tableData"
          stripe
          size="small"
          @row-click="chooseTableItem"
          style="width: 100%;height: calc(100% - 40px);background-color: rgb(239,243,247)"
        >
          <!--<el-table-column prop="time" label="历史检查时间"></el-table-column>-->
          <!--<el-table-column prop="id_in_hospital" label="历史检查编号" width="180"></el-table-column>-->
          <!--<el-table-column prop="applicant" label="申请医生" width="180"></el-table-column>-->
          <el-table-column prop="diagnosisType" label="项目" width="50px" show-overflow-tooltip></el-table-column>
          <el-table-column prop="typeArr" label="检查类型" width="90px" show-overflow-tooltip></el-table-column>
          <el-table-column prop="position_detail_list" label="部位" width="80px" show-overflow-tooltip></el-table-column>
          <el-table-column prop="doctor_conclusion" label="诊断结果" width="80px" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </div>
    <!--<div v-if="dialogVisible" class="edit-box" v-drag>
  <EditImg
    v-on:getImgSrc="getImgSrc"
    ref="mychild"
    :imglist="currentTagImages"
    :index="currentEditorIndex"
    v-on:cancel="closeEdit"
  />
</div>-->
    <el-dialog
      :visible.sync="dialogVisible"
      center
      custom-class="similarDialog showBigImage_dialog"
      modal
      top="0"
      :fullscreen="true"
      :before-close="closeShowLargeImage"
      v-if="showLargeImage"
    >
      <div
        style="position: absolute;left: 20px;right: 20px;top: 45px;bottom:20px;display: flex;align-items: center">
        <CompareImage
          :primevalImage="primevalImage"
          :compareImageList="compareImageList"
          :isCompareImage="isCompareImage"
          :largeImgage="largeImgage"
          :largeImgage2="largeImgage2"
          :imageCompileClass="imageCompileClass"
          :imageCompileClass2="imageCompileClass2"
          :selected="selected"
          :selected2="selected2"
          :activeImage="activeImage"
          :activeImage2="activeImage2"
          @imageClick="imageClick"
          @imageDblclick="imageDblclick"
          @imageOnload="imageOnload"
          @checkImageCompile="checkImageCompile"
          v-on:getImgSrc="getImgSrc"
        ></CompareImage>
      </div>
    </el-dialog>
    
    
    <transition name="fade">
      <div v-if="resiltsVisible" class="resilts">
        <el-button
          @click="closeResult"
          style="position: absolute;right: 5.6rem;top: 2.5rem;z-index:999;"
          type="primary"
          icon="el-icon-close"
          circle
        ></el-button>
        <DetailedResults
          :wordbook="wordbook"
          :detail_result="detail_result"
          :imgList="imgList3"
          v-on:compare="compare"
        />
      </div>
    </transition>
    <div
      class="mask"
      v-if="resiltsVisible || showDiagnoseRecord"
      @click="closeResult"
    ></div>
    <div
      class="mask"
      v-if="isTakePhone"
      @keydown="keydownTakePicture"
      tabindex="-1"
    ></div>
    <diagnose-record
      v-if="showDiagnoseRecord"
      v-on:message="messagediagnoserecord"
      :allDiagnoses="diagnosesRecordList"
      :activeId="choosedTableId"
      :wordBook="wordbook"
      :id="patient_id"
      :selectedDiagnosisType="selectedDiagnosisType"
    ></diagnose-record>
    <!-- <transition name="fade">
  <div v-if="showPort" class="print-content" id="printWrapper">
    <PrintReport :data="form" :data2="form2" :images="reportObj" :advise="advise" :isHostory="true" :isDownLoad="newDownLoad"
                 :id="diagnosisId" v-on:message="printMessage"/>
  </div>
</transition>-->
    <!-- <transition name="fade">
  <div v-if="showSepPort" class="print-content" id="printWrapper">
    <PrintReport :data="form" :data2="currentDiagnose" :images="reportObj" :advise="advise" :isHostory="false" :isDownLoad="isDownLoad"
                 :id="diagnosisId" v-on:message="printMessage"/>
  </div>
</transition>-->
    <iframe hidden ref="iframePDF"></iframe>
    
    <transition name="fade">
      <div v-show="showBigList" class="big-img-content">
        <div class="big-img">
          <h1>
            查看大图
            <i @click="closeBigList" class="el-icon-close"></i>
          </h1>
          <swiper ref="mySwiper" @slideChange="swiperChange" :options="swiperOption">
            <swiper-slide v-for="(item2,index) in imgList" :key="index">
              <div style="width:100%;text-align:center">
                <img :data-src="item2.path.replace('thumbnails/','')"  class="swiper-lazy">
                <div class="swiper-lazy-preloader"></div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
          <div class="myswiper-pagination"></div>
        </div>
      </div>
    </transition>
    <el-dialog title="删除" :visible.sync="centerDialogVisible" width="30%" center>
      <span style="font-size:24px">确认删除此图像？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDeletion">确 定</el-button>
      </span>
    </el-dialog>
    <div v-show="isTakePhone" class="camera-con" tabindex="-1" @keydown="keydownTakePicture" ref="cameraCon">
      <div class="booth">
        <div class="titleCon">
          <div class="leftCon">
            <img src="../assets/camera.png" style="width:30px;height:auto;">
            <div style="margin-left:10px;">影像采集</div>
          </div>
          <el-select
            class=""
            v-model="selectCamera"
            placeholder="没有找到设备"
            no-data-text="没有可选设备"
            @change="cameraChange"
          >
            <el-option
              v-for="item in CameraList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div>
            <el-select
              class=""
              v-model="selectPhotoSize"
              @change="changePhotoSize"
            >
              <el-option
                v-for="item in photoSizeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-popover
              placement="top"
              title="提示"
              width="200"
              trigger="hover"
              content="若显示器分辨率不大于1920*1080，请选择图片存储尺寸不大于1280*960；若为4K显示器，请选择图片存储尺寸为1920*1440。"
            >
              <i slot="reference" class="el-icon-question popTips" style="font-size:20px"></i>
            </el-popover>
          </div>
          <!--<div class="rightCon" v-if="skin">-->
          <!--<button class="btn" @click="jr">浸润（空格键）</button>-->
          <!--<button class="btn" @click="pz" style="margin-right:10px;">偏振光</button>-->
          <!--</div>-->
          <el-select v-model="selectSkinType" placeholder="请选择" v-if="skin">
            <el-option
              v-for="item in SkinType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="rightCon">
            <div class="btn" @click="takePicture"
                 style="margin-right:10px;width: 150px;height: 30px;box-sizing: border-box;font-size:14px;user-select: none;">
              拍摄（空格键）
            </div>
          </div>
          <img
            src="../assets/close.png"
            style="width:30px;height:auto;cursor:pointer;margin-right: 16px;"
            @click="closeCamera"
          >
        </div>
        <div
          style="position: relative;"
          v-loading="takePhotoLoading"
          element-loading-text="正在上传"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.2)"
        >
          <video
            id="video"
            ref="video"
            muted
            style="width:98%;margin-left:1%;margin-bottom: 10px;"
            @click="takePicture"
            @canplay="videoCanPlay"
          ></video>
          <div class="video-flash" v-show="isShowVideoFlash"></div>
        </div>
        <canvas id="canvas" :width="videoWidth" :height="videoHeight" ref="imgCanvas"
                style="opacity:0;z-index: -1"></canvas>
      </div>
    </div>
    <el-dialog
      :visible.sync="deletePositionDialog"
      style="border-radius:10px;"
      width="30%"
      title="删除"
    >
      <span>确定要删除{{willDeletePosition}}吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDeletePosition">取 消</el-button>
        <el-button type="primary" @click="confirmDeletePosition">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="相似图片对比"
      :visible.sync="compareDialog"
      width="90%"
      center
      top="36px"
      custom-class="similarDialog"
      modal
    >
      <div class="imgWrapper">
        <div class="chooseImgCon">
          <div class="cs-text">选择图片</div>
          <img
            :src="compareImgObj.choosedImg"
            :class="{'silimarImageWidth':!compareImgObj.isWidth1,'silimarImageHeight':compareImgObj.isWidth1}"
          >
          <div class="cs-text">&nbsp;</div>
        </div>
        <div class="chooseImgCon">
          <div class="cs-text">相似图片（相似度{{(Number(compareImgObj.similarity)*100).toFixed(2)}}%）</div>
          <img
            :src="compareImgObj.compareImg"
            :class="{'silimarImageWidth':!compareImgObj.isWidth2,'silimarImageHeight':compareImgObj.isWidth2}"
          >
          <div class="cs-text">{{compareImgObj.disease_desc}}</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-pic"
      :visible.sync="showLargeImage3"
      center
      custom-class="similarDialog showBigImage_dialog_1"
      modal
      top="0"
      :fullscreen="true"
      @close="closePic"
    >
      <div class="bigImage">
        <Lookimage :largeImgage="largeImage3"></Lookimage>
        <div class="next-btn iconfont" @click.stop="showNextPic">&#xe6e8a;</div>
        <div class="previous-btn iconfont" @click.stop="showPreviousPic">&#xe61ba;</div>
      </div>
    </el-dialog>
    <div>
      <router-view/>
      <UpdateAnnouncement></UpdateAnnouncement>
    </div>
  </div>
</template>
<script>
  import getUserMedia from "../getUserMedia.ts";
  import api from "../api";
  import axios from "axios";
  import DetailedResults from "./DetailedResults.vue";
  // import PrintReport from "./PrintReport.vue";
  import GeneralPlan from "./GeneralPicture.vue";
  import CollectionType from "./CollectionType.vue";
  import csrftoken from "../getToken";
  import moment from "../../node_modules/moment/src/moment.js";
  import DiagnoseRecord from "./DiagnoseRecord.vue";
  import "swiper/dist/css/swiper.css";
  import {swiper, swiperSlide} from "vue-awesome-swiper";
  import {mapState, mapMutations, mapGetters} from "vuex";
  import Tree from "./Tree.vue";
  // import addDiagnosisGql from '../gql/addDiagnosis.gql'
  // 民族json对象
  import raceJson from "../race.js";
  import gql from "graphql-tag";
  import Util from "../utils/utils.js";
  import _ from "lodash";
  import {clearUnderMirror} from "../utils/clearUnderMirror.js";
  import {checkImage} from "../utils/imageAuto.js";
  import {lookPhoto} from "../utils/lookPhoto.js";
  import popMixins from "../utils/popMixins.js";
  import intellController from "../utils/intellController.js";
  import {printReport} from "../utils/printReport.js";
  import CompareImage from './CompareImage';
  import photoSize from '../utils/photosSize.js';
  import Lookimage from './LookBigImage.vue';
  // 版本升级后，提示用户此次升级内容，只在首次显示
  import UpdateAnnouncement from "./UpdateAnnouncement.vue"

  let template = {};
  
  let that;
  
  const differentContent = {};
  if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
    // differentContent.errorCon = '请先进行智能搜图!!';
    differentContent.errorCon = '请先进行以图搜图!!';
  } else {
    differentContent.errorCon = '请先进行以图搜图!!';
  }
  
  export default {
    name: "Intelligent",
    beforeCreate() {
      that = this;
    },
    data() {
      const checkIdInHospital = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
          /*clearTimeout(this.timer);
          this.timer = setTimeout(async () => {
            if (this.useID) {
              callback();
            } else {
              if (!this.fromNewDiagnose) {
                if (!this.found) {
                  
                  const obj = await this.patientIdRepeat(value);
                  // 如果找到患者就将患者信息填入
                  if (obj.id) {
                    callback('');
                    this.$message.error('ID已存在');
                    /!*this.useID = true;
                    this.isReset = true;
                    this.readonly = true;
                    this.fromNewDiagnose = true;
                    const birthday = moment(obj.birthday).format("YYYY-M-D");
                    this.form.id = obj.id;
                    this.form.id_in_hospital = obj.id_in_hospital;
                    this.form.name = obj.name;
                    this.form.birthday = birthday;
                    this.form.skin_color = obj.skin_color;
                    this.form.gender = obj.gender;
                    this.form.phone = obj.phone;
                    this.form.race = obj.race;
                    this.form.address = obj.address;
                    this.form.idCardNumber = obj.id_card_number;
                    this.form.nativePlace = obj.native_place;
                    this.form.country = obj.country;
                    this.form.profession = obj.profession;
                    this.form.email = obj.email;
                    this.patient_id = obj.id;
                    // 请求历史诊断列表
                    this.getHistoryCheckData();*!/
                  } else {
                    callback();
                  }
                  callback();
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }
          }, 300);*/
        }
      };
      const checkFee = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
          if (reg.test(value)) {
            callback();
          } else {
            this.$message.error("请输入合法的费用!!");
            callback("");
          }
        }
      };
      // 检查生日
      const checkBirthday = (rule, value, callback) => {
        let reg = /^(?:(?!0000)[0-9]{4}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[0-9]{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[13579][26])00)-02-29)$/;
        if (value === "") {
          callback("");
        } else {
          if (reg.test(value)) {
            callback();
          } else {
            callback("");
          }
        }
      };
      // 检查用户名
      const checkName = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
        }
      };
      // 校验电话号码
      const checkPhone = (rule, value, callback) => {
        let reg = /^1\d{10}/;
        if (reg.test(value)) {
          callback();
        } else {
          callback("");
        }
      };
      const checkSkin = (rule, value, callback) => {
        if (value) {
          callback("");
        } else {
          callback();
        }
      };
      const checkApplyDoctor = (rule, value, callback) => {
        if (typeof value !== "string") {
          callback("");
        } else {
          if (value === "") {
            callback("");
          } else {
            callback();
          }
        }
      };
      const checkUnit = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
        }
      };
      const checkDiagnoseNum = async (rule, value, callback) => {
        if (value === "") {
          callback("");
        }
      };
      const checkcheckId = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
        }
      };
      const checkEmail = (rule, value, callback) => {
        let reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
        if (value === "") {
          callback();
        }
        if (reg.test(value)) {
          callback();
        } else {
          this.form.email = "";
          callback("");
        }
      };
      
      return {
        differentContent,
        imageSrcPrefixThumbnails: api.imageSrcPrefixThumbnails,
        imageSrcPrefix: api.imageSrcPrefix,
        // 是否已选择id
        useID: false,
        // 验证id的定时器
        // 新建患者成功后状态改变
        found: false,
        timer: null,
        newDownLoad: false,
        // 显示特定的诊断
        showSepPort: false,
        currentDiagnose: {},
        showLargeImage: false,
        largeImage: "",
        textAreaMaxLen: 512,
        // 是否显示input框验证状态
        isShowStateIcon: true,
        // 新建患者重新渲染该组件
        newP: true,
        // 其他描述
        otherDescription: "",
        allReport: [],
        // 皮肤镜报告对象
        skinReportObj: {},
        // 大体图报告对象
        genralReportObj: {},
        // ct报告对象
        ctReportObj: {},
        // bc报告对象
        bcReportObj: {},
        // 病理报告对象
        blReportObj: {},
        figureObj: raceJson.position.man,
        // 是否收藏
        isCollection: false,
        // 将要被删除的部位
        willDeletePosition: "",
        // 是否显示诊断记录
        showDiagnoseRecord: false,
        // 诊断结果
        diagnoseResult: "",
        // 医生建议
        advise: "",
        // 百科筛选字段
        filterText: "",
        defaultProps: {
          children: "children",
          label: "name"
        },
        // 选中表格的id
        choosedTableId: 0,
        // 是否显示检查部位的一级菜单
        checkoverview: false,
        checkoverviewMax: false,
        // 申请医生的列表
        applyDoctors: [],
        // 是否存在申请医生的列表
        applyDoctorsExist: false,
        patientMore: true,
        checkMore: true,
        showPatientFormMaxDialog: false,
        showCheckFormMaxDialog: false,
        NoShow: false,
        isTakePhone: false,
        // 申请单位
        applyUnitData: raceJson.applyUint,
        // 疾病预览结果
        overview_result: [],
        compareImgObj: {},
        // 删除部位的索引
        deletePositionIndex: 0,
        compareDialog: false,
        // 民族的可选项
        // 显示智能搜图弹框
        showIntelligentSearch: false,
        races: raceJson.raceObj,
        fileList: [],
        value: "",
        value2: "",
        currentImg: "",
        dialogVisible: false,
        currentIndex: -1,
        currentIndex2: -1,
        imgList: [],
        imgList2: [],
        imgList3: [],
        // 显示报告
        showPort: false,
        // 报告图片数组
        /**
         * {
         *    "ct": [{id: "",path:""},{id: "",path: ""}],
         *    "bc": [{id: "",path:""},{id: "",path: ""}],
         *    "general": [{id: "",path:""},{id: "",path: ""}],
         *    "skin": [{id: "",path:""},{id: "",path: ""}],
         *    "bl": [{id: "",path:""},{id: "",path: ""}],
         * }
         */
        reportImgs: [],
        test: "",
        activeName2: "first",
        mediaStreamTrack: null,
        index: "",
        patient_id: "",
        star: "el-icon-star-off",
        tagged: 0,
        file: "",
        report: "",
        resiltsVisible: false,
        loading: false,
        disabled: false,
        wordbook: null,
        resultData: {},
        isHid: false,
        detail_result: [],
        isCorrect: false,
        doctor_conclusion: "",
        viewResults: 0,
        response_time: "",
        checkedIndex: [],
        report_images: [],
        // 控制tag变化的内容
        isGeneral: false,
        isCT: false,
        isBC: false,
        skin: false,
        bl: false,
        tagObj: {},
        form: {
          id: "",
          // 患者id
          id_in_hospital: "",
          // 姓名
          name: "",
          birthday: "",
          age: '',
          skin_color: "",
          skin_type: "",
          gender: "男",
          phone: "",
          // 手机号码2
          phone2: "",
          // 民族
          race: "",
          // 地址
          address: "",
          // 身份证号
          idCardNumber: "",
          // 籍贯
          nativePlace: "",
          country: "",
          // 职业
          profession: "",
          email: "",
          // 文化程度
          education: "",
          // 是否吸烟
          smoking: "",
          // 是否饮酒
          drinking: "",
          // 饮食习惯
          dietHabitArr: [],
          diet_habit: "",
          // 身高
          height: "",
          // 体重
          weight: "",
          // 备注
          note: "",
          created_time: '',
        },
        // 可选标签
        tags: [
          {
            text: "大体图/伍德灯",
            text2: "edit_DTT",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          },
          {
            text: "皮肤镜",
            text2: "edit_PFJ",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          },
          {
            text: "CT",
            text2: "edit_CT",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          },
          {
            text: "B超",
            text2: "edit_BC",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          },
          {
            text: "病理",
            text2: "edit_BL",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          }
        ],
        // 校验患者信息的规则
        patientRules: {
          id_in_hospital: {
            required: false,
            validator: checkIdInHospital,
            trigger: "blur"
          },
          
          name: {required: false, validator: checkName, trigger: "blur"},
        },
        checkRules: {
          // applicant: {
          //   required: false,
          //   validator: checkApplyDoctor,
          //   trigger: "change"
          // },
          // applicant_unit: {
          //   required: false,
          //   validator: checkUnit,
          //   trigger: "change"
          // },
          // unit: {
          //   required: false,
          //   validator: checkUnit,
          //   trigger: "change"
          // },
          // id_in_hospital: {
          //   required: false,
          //   validator: checkDiagnoseNum,
          //   trigger: "blur"
          // },
          // initial_conclusion: {
          //   required: false,
          //   validator: checkUnit,
          //   trigger: "blur"
          // },
          // review_doctor: {
          //   required: false,
          //   validator: checkUnit,
          //   trigger: "change"
          // },
          
          // fee: {required: false, validator: checkFee, trigger: "change"},
          // checkId: {required: false, validator: checkcheckId, trigger: "blur"}
        },
        form2: {
          // 申请医生
          applicant: "",
          applicant_unit: "",
          review_doctor: "",
          // 单位
          unit: "",
          // 门诊诊断
          initial_conclusion: "",
          // 检查编号
          id_in_hospital: "",
          // 检查费用
          fee: "",
          // patient_id患者id
          // 检查部位
          position_overview_list: "",
          // 具体位置
          position_detail_list: "",
          // 主诉
          complaint: "",
          // 现病史
          disease_history_present: "",
          // 病史
          disease_history_before: "",
          // 体格检查
          physical_examination: "",
          // 过敏史
          allergy_history: "",
          // 家族史
          disease_history_family: "",
          // 实验室
          lab: ""
        },
        skinOps: raceJson.skinOpn,
        skinOpsType:raceJson.skinOpnType,
        professionOpts: raceJson.professionOptions,
        educationOpts: raceJson.educationOptions,
        smokingOpts: raceJson.smokingOptions,
        drinkingOpts: raceJson.drinkingOptions,
        dietHabitOpts: raceJson.dietHabitOptions,
        options: Object.keys(raceJson.position.man),
        options2: null,
        tableData: [],
        diagnosisId: -1,
        restaurants: [],
        isReset: false,
        readonly: false,
        isResult: false,
        currentType: "",
        showBigList: false,
        swiperOption: {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          pagination: {
            el: ".myswiper-pagination",
            clickable: true
          }
        },
        // mirrorType: [Util.GENERAL.code, Util.SOAK.code, Util.POLARRIZE.code, Util.CT.code, Util.BC.code ,Util.PATHOLOGY.code],
        centerDialogVisible: false,
        deleteImgIndex: "",
        deleteImgId: "",
        editImgId: "",
        fromNewDiagnose: false,
        fromDetailDiagnose: false,
        // 当前编辑的第几张图片
        currentEditorIndex: 0,
        // 一级菜单所悬浮的当前索引
        topLevelIndex: 0,
        // 二级菜单所悬浮的当前索引
        secondLevelIndex: 0,
        // 选择的位置的数组
        choosedPosition: [],
        // 移动到已选择部位的索引
        choosedPositionIndex: 0,
        // 删除该部位提示
        deletePositionDialog: false,
        knowledgeData: [],
        // 诊断记录
        diagnosesRecordList: [],
        // 历史检查记录id数组
        historyDiagnoseIds: [],
        // 是否是新的诊断
        isNewDiagnose: false,
        // 申请单位
        applyUnit: [],
        // 审核医生
        review_doctor_cache: [],
        // 检查单位
        check_unit: [],
        // 是否禁用智能搜图
        disableIntell: false,
        // 生成报告时候的报告对象
        reportObj: {},
        // 病的id
        diseaseId: -1,
        // 所有病的名字
        allDisease: [],
        reloadCollection: true,
        overviewList: [],
        detailList: [],
        // 费用列表
        feeList: [],
        // tree类型
        diagnoseType: "",
        hospital_id_disabled: false,
        patient_id_disabled: false,
        
        knowledgeDic: {},
        template: {},
        diseaseid: "",
        treeReload: true,
        selectedDiagnose: false,
        diagnose_id_in_hospital: "",
        scrollChange: false,
        isShowMenu: false,
        // 控制是否填上检查信息
        isHandleExamineInfo: false,
        // 防止blur事件和selectedDisease重复触发的状态
        isTrigger: false,
        // 点击编辑跳转过来时传入模板中的镜下所见数据
        reportText: {},
        // 选择的相机
        selectCamera: '',
        // 相机列表
        CameraList: [],
        picType: '',
        // 皮肤镜类型
        SkinType: [
          {
            value: '2',
            label: '浸润',
          },
          {
            value: '4',
            label: '偏振光',
          },
        ],
        // 选择拍摄皮肤镜类型
        selectSkinType: '4',
        initialTime: -30610253143000, // 初始时间1000-01-01 00:00:00
        tracks: [],
        isProcessing: false,
        // 拍摄的摄像头像素
        videoWidth: 0,
        videoHeight: 0,
        takePhotoLoading: false,
        selectedDiagnosisType: '',
        isShowVideoFlash: false,
        // 查看单张大图相关数据
        showLargeImage3: false,
        largeImage3: '',
        currentPicPath: '',
        // 是否显示建议模板
        isShowSuggestionTemplate: false,
        // 建议模板
        suggestionTemplate: [],
        // 是否显示备注模板
        isShowRemarksTemplate:false,
        // 备注模板
        remarksTemplate: [],
        // 要删除的图片的id
        deleteImageId: -1,
        // 打印报告的同时，是否生成或者更新云胶片
        needGenOnlineReport: false
      };
    },
    mixins: [clearUnderMirror, lookPhoto, printReport,popMixins,intellController,photoSize],
    async mounted() {
      // 显示存储空间不足提示
      this.showStorageRateMsg();

      await this.queryMyTemplate();
      let res1 = await axios.request({
        method: "get",
        url: api.wordbook,
        headers: {
          "x-csrf-token": csrftoken
        },
        withCredentials: true
      });
      this.wordbook = res1.data;
      // 获取 localStorage 缓存的信息
      if (!!localStorage.getItem("applyUnit")) {
        this.applyUnit = JSON.parse(localStorage.getItem("applyUnit"));
      }
      if (!!localStorage.getItem("reviewDoctorCache")) {
        this.review_doctor_cache = JSON.parse(
          localStorage.getItem("reviewDoctorCache")
        );
      }
      if (!!localStorage.getItem("checkUnit")) {
        this.check_unit = JSON.parse(localStorage.getItem("checkUnit"));
      }
      if (!!localStorage.getItem("applyDoctors")) {
        this.applyDoctorsExist = true;
        this.applyDoctors = JSON.parse(localStorage.getItem("applyDoctors"));
      } else {
        this.applyDoctorsExist = false;
      }
      if (!!localStorage.getItem("fee")) {
        this.feeList = JSON.parse(localStorage.getItem("fee"));
      }
      
      
      // console.log("In Intelligent.vue, get query:", this.$route.query);
      // if(this.$route.query){
      //   if(this.$route.query.diagnosisId){
      //     const diagnosisId = this.$route.query.diagnosisId;
      //     //将Flag 从 sessionStorage传递给 store.stat.addModifyDiagnosis，后续多个操作都要依赖于该值
      //     this.$store.commit("addModifyDiagnosis", {
      //       diagnosisId
      //     });          
      //   }
      // }

      if(this.$route.query){
        if(this.$route.query.from){
          // 从患者列表点击新建，打开新页面，利用query在新老页面之间传输参数
          if (this.$route.query.from=="newDiagnosis"){        
            const params = this.$route.query;
            this.$store.commit("setPToIntell", params);
            this.$route.query.from = "";   
          }   
          // 从患者列表点击编辑,打开新页面，利用query在新老页面之间传输参数
          // console.log("In Intelligent.vue, state.modifyDiagnosisData.isModify:",this.$store.state.modifyDiagnosisData.isModify)
          // console.log("In Intelligent.vue, window.sessionStorage.getItem.diagnosisParams",window.sessionStorage.getItem("diagnosisParams"))
          if (this.$route.query.from=="modifyDiagnosis"){   
            const diagnosisId = this.$route.query.diagnosisId;
            //将Flag 传递给 store.stat.addModifyDiagnosis，后续多个操作都要依赖于该值
            this.$store.commit("addModifyDiagnosis", {
              diagnosisId
            }); 
            this.$route.query.from = "";   
          }      
        }
      }

      // 如果是点击编辑跳转过来就执行. 根据diagnosisId获取其他数据并填充到页面
      if (this.$store.state.modifyDiagnosisData.isModify) {        
        // console.log("In Intelligent.vue, begin handleModifyDiagnosisData");
        await this.handleModifyDiagnosisData();
      }
      if (this.isHandleExamineInfo) {
        this.handleExamineInfo()
      }
      
      let params = this.$router.currentRoute.params;
      // console.log("In intelligent, mounted(), $router.currentRoute.params:", params);

      // 暂时无用
      switch (params.from) {
        case "patientListNewDialoges":
          break;
        case "diagnoseDetial":
          this.patient_id = params.pId;
          this.getHistoryCheckData();
          this.diagnosisId = params.dId;          
          break;
      }
      const myDate = (function getNowFormatDate() {
        const date = new Date();
        const seperator1 = "-";
        const seperator2 = ":";
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        const currentdate =
          date.getFullYear() +
          seperator1 +
          month +
          seperator1 +
          strDate +
          " " +
          date.getHours() +
          seperator2 +
          date.getMinutes() +
          seperator2 +
          date.getSeconds();
        return currentdate;
      })();
      let self = this;
      this.$nextTick(() => {
        self.video = self.$refs.video;
        self.canvas = self.$refs.imgCanvas;
        self.img = self.$refs.img;
      });
      // 请求皮肤镜报告模板数据
      axios
        .request({
          method: "get",
          url: api.knowledge
        })
        .then(res => {
          this.knowledgeData = res.data.children;
        });
      this.isHandleExamineInfo = false;
      if (window.localStorage.getItem('skinType')) {
        this.selectSkinType = window.localStorage.getItem('skinType');
      }
      if (!this.readonly) {
        if (this.$refs.idInput) {
          this.$refs.idInput.focus();
        }
      }
      document.addEventListener('click', () => {
        this.isShowSuggestionTemplate = false;
        this.isShowRemarksTemplate = false;

      });

      // 根据用户权限，设置是否生成云胶片的Flag。
      if (this.$store.state.controller.auths.indexOf('gen_online_report')>-1) {
        this.needGenOnlineReport = true;
      } else{
        this.needGenOnlineReport = false;
      }
    },
    computed: {
      ...mapGetters(["getReportImgs", "getPToIntell"]),
      // 选中的部位
      activePosition() {
        let activedPosition;
        for (let i = 0; i < this.choosedPosition.length; i++) {
          if (this.choosedPosition[i].active) {
            activedPosition = this.choosedPosition[i];
          }
        }
        return activedPosition;
      },
      // 当前所选择标签下的图片数组
      currentTagImages() {
        let backArr = [];
        if (this.isGeneral) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i].type === Util.GENERAL.code) {
              backArr.push(this.imgList[i]);
            }
          }
        } else if (this.isCT) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i].type === Util.CT.code) {
              backArr.push(this.imgList[i]);
            }
          }
        } else if (this.isBC) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i].type === Util.BC.code) {
              backArr.push(this.imgList[i]);
            }
          }
        } else if (this.skin) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (
              this.imgList[i].type === Util.SOAK.code ||
              this.imgList[i].type === Util.POLARRIZE.code
            ) {
              backArr.push(this.imgList[i]);
            }
          }
        } else if (this.bl) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i].type === Util.PATHOLOGY.code) {
              backArr.push(this.imgList[i]);
            }
          }
        }
        return backArr;
      }
    },
    // 监听属性值变化
    watch: {
      compareDialog(newval) {
        if (!newval) {
          this.compareImgObj = {};
        }
      },
      getPToIntell: {
        handler(newval, oldval) {
          if (!!this.$store.state.pToIntellParams) {
            this.$store.state.chooseItImgArr = [];
            let params = this.$store.state.pToIntellParams;
            this.form.id = params.id;
            this.form.created_time = params.created_time;
            this.form.id_in_hospital = params.id_in_hospital;
            this.form.birthday = params.birthday === moment(this.initialTime).format('YYYY-MM-DD') ? '' : params.birthday;
            this.form.age = params.age > -1 ? (params.age + '') : '';
            this.form.id_card_number = params.id_card_number;
            this.form.phone = params.phone;
            this.form.profession = params.profession;
            this.form.gender = params.gender;
            this.form.name = params.name;
            this.form.race = params.race;
            this.form.skin_color = params.skin_color;
            this.form.skin_type = params.skin_type;
            this.form.address = params.address;
            this.form.idCardNumber = params.id_card_number;
            this.form.nativePlace = params.native_place;
            this.form.country = params.country;
            this.form.email = params.email;
            this.form.phone2 = params.phone2 || '';
            this.form.education = params.education || '';
            this.form.smoking = params.smoking || '';
            this.form.drinking = params.drinking || '';
            this.form.dietHabitArr = params.diet_habit ? params.diet_habit.split(',').filter(s => s) : [];
            this.form.diet_habit = params.diet_habit || '';
            this.form.height = params.height || '';
            this.form.weight = params.weight || '';
            this.form.note = params.note || '';
            this.patient_id = params.id;
            this.getHistoryCheckData();
            this.readonly = true;
            this.isNewDiagnose = true;
            this.fromNewDiagnose = true;
            this.$store.commit("clearPToIntell");
            this.isHandleExamineInfo = true
          }
          // 开启新的诊断
        },
        immediate: true,
        deep: true
      },
      needGenOnlineReport(newval) {
        if(newval){
          if(!this.form.phone){
            this.$message({
              message: "生成或者更新云胶片，并随后发送短信通知，必须确保患者手机号不为空！",
              type: "warning"
            })
          }
        }
      }
    },
    async created() {
      // if (this.$store.state.loginLoading) {
      //   this.$store.state.loginLoading.close();
      // }
     
      this.$root.$on('connect2server', () => {
        if (sessionStorage.getItem("username")) {
          if (window.eventSrc) {
            window.eventSrc.close();
          }
          window.eventSrc = new EventSource(api.event, {
            withCredentials: true
          });
          window.eventSrc.onmessage = async event => {
            this.$root.$emit(event.data);
          };
          
          window.eventSrc.onopen = () => {
            window.lastHeartBeat = new Date();
          };
          // Ai搜图事件返回结果
          window.eventSrc.addEventListener("ai_diagnosis_result", event => {
            const response = JSON.parse(event.data);
            that.overview_result = response.detail_result;
            that.detail_result = response.detail_result;
            that.loading = false;
            that.resultData = response;
            // 解禁按钮
            that.disableIntell = false;
            that.isHid = true;
            that.isResult = true;
            that.$message({
              message: "成功",
              type: "success"
            });
          });
          window.eventSrc.addEventListener("hb", event => {
            window.lastHeartBeat = new Date();
          });
        }
      });
      if (!sessionStorage.getItem("username")) {
        // 获取检查医生
        this.$router.push({path: "/login"});
      }
      this.$root.$on("refresh-diagnosis-images", async () => {
        if (this.diagnosisId && this.diagnosisId !== -1) {
          await this.loadImages();
        }
      });
      // 获取报告模板病名与id文件
      try {
        const knowledgeDic = await axios.request({
          method: "get",
          url: api.knowledgeDic
        });
        this.knowledgeDic = knowledgeDic.data;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    beforeDestroy() {
      this.$root.$off("refresh-diagnosis-images");
      this.clearPortData();
    },
    methods: {
      // 上传完成之前显示缩略图
      showThumbnailImage(imgObjArr) {
        const thumbnailImgArr = imgObjArr.map((item) => ({
          path: 'data:image/jpeg;base64,' + item.base64,
          type: item.type,
          position_detail: item.position_detail,
          position_overview: item.position_overview,
          showLoadingIcon: true,
          upload_mark: item.upload_mark,
        }));
        this.imgList = this.imgList.concat(thumbnailImgArr);
      },
      async handleSaveSuggestionTemplate() {
        if (!this.advise) {
          return
        }
        console.log(this.suggestionTemplate)
        this.suggestionTemplate.push({value: this.advise})
        this.saveSuggestionTemplate();
      },
      async handleSaveReportTemplate(){
        if (!this.otherDescription) {
          return
        }
        console.log(this.remarksTemplate)
        this.remarksTemplate.push({value: this.otherDescription})
        this.saveRemarksTemplate();
      },
      async saveRemarksTemplate(){
        try {
          const res = await this.$apollo.query({
            query: gql`{
              me{
                id
              }
            }`,
            fetchPolicy: "no-cache",
          });
          const a = JSON.stringify(this.remarksTemplate);
          const res1 = await this.$apollo.mutate({
            mutation: gql`mutation(
              $id: Int!
              $remarks_templ: String
            ){
              modifyDoctor(
                id: $id
                remarks_templ: $remarks_templ
              )
            }`,
            variables: {
              id: res.data.me.id,
              remarks_templ: a,
            }
          });
          this.$message({
            message: "保存成功",
            type: "success"
          });
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 请求接口保存建议模板
      async saveSuggestionTemplate() {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              me{
                id
              }
            }`,
            fetchPolicy: "no-cache",
          });
          const a = JSON.stringify(this.suggestionTemplate);
          const res1 = await this.$apollo.mutate({
            mutation: gql`mutation(
              $id: Int!
              $suggestion: String
            ){
              modifyDoctor(
                id: $id
                suggestion: $suggestion
              )
            }`,
            variables: {
              id: res.data.me.id,
              suggestion: a,
            }
          });
          this.$message({
            message: "保存成功",
            type: "success"
          });
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      selectRemarksTemplate(value){
        this.otherDescription = value;
        this.isShowRemarksTemplate = false;
        this.modifyDoctorReport();
      },
      deleteRemarksTemplate(index){
        this.remarksTemplate.splice(index, 1);
        this.saveRemarksTemplate();
      },
      // 点击选择建议模板
      selectSuggestionTemplate(value) {
        this.advise = value;
        this.isShowSuggestionTemplate = false;
        this.saveSuggestion();
      },
      // 删除建议模板
      deleteSuggestionTemplate(index) {
        this.suggestionTemplate.splice(index, 1);
        this.saveSuggestionTemplate();
      },
      // 显示备注模板
     async showReportTemplate(){
       try {
         const res = await this.$apollo.query({
           query: gql`{
              me{
                id
                remarks_templ
              }
            }`,
           fetchPolicy: "no-cache",
         });
         if (res.data.me.remarks_templ) {
           // console.log(res.data.me.suggestion)
           // this.remarksTemplate = []
           this.remarksTemplate = JSON.parse(res.data.me.remarks_templ);
         } else {
           this.remarksTemplate = [];
         }
         this.isShowRemarksTemplate = true;
       } catch (error) {
         this.$message.error(error.message.split(":")[1]);
       }
      },
      // 显示建议模板
      async showSuggestionTemplate() {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              me{
                id
                suggestion
              }
            }`,
            fetchPolicy: "no-cache",
          });
          if (res.data.me.suggestion) {
           // console.log(res.data.me.suggestion)
            this.suggestionTemplate = JSON.parse(res.data.me.suggestion);
            // this.suggestionTemplate.push()
          } else {
            this.suggestionTemplate = [];
          }
          this.isShowSuggestionTemplate = true;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 将诊断结果保存到自定义模板中
      addDiagnosisToMyTemplate() {
        if (this.patient_id === "") {
          this.$message.error("请添加患者信息!");
          return;
        }
        if (this.diagnosisId === -1) {
          this.$message.error("请添加检查部位!");
          return;
        }
        if (this.diagnoseResult === '') {
          this.$message.error("请添加诊断结果!");
          return;
        }
        this.$refs.myTree.addDiagnosisToMyTemplate(this.diagnoseResult);
      },
      // 查看单张大图操作
      showPic(path) {
        this.currentPicPath = path;
        this.largeImage3 = `${this.imageSrcPrefix}${path}`;
        this.showLargeImage3 = true;
      },
      showNextPic() {
        const findIndex = this.imgList.findIndex((item) => item.pathName === this.currentPicPath);
        if (findIndex > -1) {
          if (this.imgList[findIndex + 1]) {
            this.showPic(this.imgList[findIndex + 1].pathName);
          } else {
            this.showPic(this.imgList[0].pathName);
          }
        }
      },
      showPreviousPic() {
        const findIndex = this.imgList.findIndex((item) => item.pathName === this.currentPicPath);
        if (findIndex > -1) {
          if (this.imgList[findIndex - 1]) {
            this.showPic(this.imgList[findIndex - 1].pathName);
          } else {
            this.showPic(this.imgList[this.imgList.length - 1].pathName);
          }
        }
      },
      closePic() {
        this.largeImage3 = '';
      },
      videoFlashPlay() {
        this.isShowVideoFlash = true;
        setTimeout(() => {
          this.isShowVideoFlash = false;
        }, 400);
      },
      suggestionHeadClick() {
        this.$refs.suggestionInput.focus();
      },
      remarkHeadClick(){
        this.$refs.remarkText.focus();
      },
      setOtherDescription(item) {
        this.$refs.otherDescription.focus();
        this.otherDescription = item;
      },
      async modifyDoctorReport() {
        if (this.diagnosisId === -1) {
          // this.$message.error('请添加诊断信息');
          return;
        }
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
                $id: Int!
                $doctor_report: String
              ){
                modifyDiagnosis(
                  id: $id
                  doctor_report: $doctor_report
                )
              }`,
            variables: {
              id: this.diagnosisId,
              doctor_report: this.otherDescription,
            }
          });
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
     
      // 根据影像诊断id查找影像诊断病名
      filterConclusion(id) {
        let name;
        // 从自定义模板中找病种名称
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
              name = data[i].name;
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (this.template.myTemplate) {
          f(this.template.myTemplate);
        }
        // 如果自定义中没有找到则在原始模板中查找
        if (!name) {
          if (that.wordbook) {
            if (that.wordbook[id]) {
              name = that.wordbook[id].name
            }
          }
        }
        return name ? name : id;
      },
      // 获取医生自定义模板
      async queryMyTemplate() {
        // 请求医生自定义的模板路径
        const res = await this.$apollo.query({
          query: gql`{
          me{
            id
            template
          }
        }`,
          fetchPolicy: 'no-cache',
        });
        // 根据路径请求模板
        const path = res.data.me.template;
        // 如果没有自定义模板
        if (path === '') {
          return;
        }
        const msg =  await axios.request({
          method: 'get',
          url: api.template + path,
        });
        template = msg.data;
      },
      // 通过id找自定义模板中对应的对象
      queryMyTemplateById(id) {
        let obj;
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
              obj = data[i];
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (this.template.myTemplate) {
          f(this.template.myTemplate);
        }
        return obj;
      },
      // 通过name找自定义模板中对应对象
      queryMyTemplateByName(name) {
        let obj;
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].name === name) {
              obj = data[i];
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (this.template.myTemplate) {
          f(this.template.myTemplate);
        }
        return obj;
      },
      async getCreatedTime(id) {
        const res = await this.$apollo.query({
          query: gql`{
            patient(id:${id}){
              id
              created_time
            }
          }`,
          fetchPolicy: "no-cache"
        });
        this.form.created_time = moment(res.data.created_time).format('YYYY-MM-DD');
      },
      keydownTakePicture(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.keyCode === 123 || e.keyCode === 32) {
          this.takePicture();
        }
      },
      // 选择了拍摄设备
      cameraChange() {
        this.showCamera();
      },
      // 获取摄像头列表
      async getCameraList() {
        if (navigator.mediaDevices || navigator.mediaDevices.enumerateDevices) {
          const enumeratorPromise = await navigator.mediaDevices.enumerateDevices();
          /*console.log(enumeratorPromise)*/
          const deviceArr = enumeratorPromise.filter(item => item.kind === 'videoinput');
          if (deviceArr.length > 0) {
            let count = 1;
            this.CameraList = deviceArr.map(item => {
              return {
                value: item.deviceId,
                label: item.label || `Camera ${count++}`,
              }
            });
            // 选中上次拍摄的设备，如果没有记忆上次拍摄的设备就默认选中第一个
            if (window.localStorage.getItem('selectCamera')) {
              const cameraId = window.localStorage.getItem('selectCamera');
              const filterDevice = deviceArr.filter(item => item.deviceId === cameraId);
              if (filterDevice.length > 0) {
                this.selectCamera = cameraId;
              } else {
                this.selectCamera = deviceArr[0].deviceId;
              }
            } else {
              this.selectCamera = deviceArr[0].deviceId;
            }
          } else {
            this.CameraList = [];
            this.selectCamera = '';
          }
        }
      },
      // 显示拍摄影像
      async showCamera() {
        try {
          if (this.selectCamera) {
            const videoConstraints = {};
            videoConstraints.deviceId = {exact: this.selectCamera};
            const constraints = {
              video: videoConstraints,
              audio: false
            };
            navigator.mediaDevices
              .getUserMedia(constraints)
              .then(stream => {
                try {
                  this.video.srcObject = stream;
                } catch (e) {
                  this.video.src = window.URL.createObjectURL(stream);
                }
                self.video.play();
                this.tracks = stream.getTracks();
              })
              .catch(error => {
                this.$message({
                  message: '请尝试取消其他程序设备占用或重新连接设备',
                  type: 'error',
                  duration: 4000,
                });
              });
          } else {
            // this.video.load();
          }
        } catch (error) {
          this.$message({
            message: '请尝试取消其他程序设备占用或重新连接设备',
            type: 'error',
            duration: 4000,
          });
        }
      },
      // 诊断详情页点击编辑跳转过来，把信息填上
      async handleModifyDiagnosisData() {
  
        const diagnosisId = this.$store.state.modifyDiagnosisData.diagnosisId;
        try {
          const res = await this.$apollo.query({
            query: gql`{
          diagnosis(id: ${diagnosisId}){
            id
            doctor {
              id
              realname
            }
            previewImage {
              id
              path
            }
            fee
            applicant
            applicant_unit
            complaint
            review_doctor
            unit
            initial_conclusion
            lab
            id_in_hospital
            position_detail_list
            position_overview_list
            disease_history_present
            disease_history_before
            physical_examination
            allergy_history
            disease_history_family
            dermoscopy_report_text
            dermoscopy_report_images
            macro_report_text
            macro_report_images
            ct_report_text
            ct_report_images
            b_ultrasonic_report_text
            b_ultrasonic_report_images
            b_ultrasonic_report_text
            b_ultrasonic_report_images
            pathology_report_text
            pathology_report_images
            doctor_conclusion
            doctor_report
            doctor_suggestion
            top1
            top2
            top3
            top1_prob
            top2_prob
            top3_prob
            tagged
            is_detail_viewed
            image_type_flag
            time
            images {
              id
              path
              tagged
              server
              type
              position_detail
              position_overview
              print_time
              time
              diagnosis{
                id
                time
              }
              origin
            }
            patient{
              id
              id_in_hospital
              name
              gender
              race
              skin_color
              skin_type
              birthday
              age
              phone
              phone2
              address
              id_card_number
              native_place
              created_time
              country
              profession
              email
              education
              smoking
              drinking
              diet_habit
              height
              weight
              note
            }
          }
        }`,
            fetchPolicy: "no-cache"
          });
          const diagnosisinfo = res.data.diagnosis;
          const patientinfo = res.data.diagnosis.patient;
          // 将患者信息填上
          this.form.id = patientinfo.id;
          this.form.created_time = moment(patientinfo.created_time).format('YYYY-MM-DD');
          this.form.id_in_hospital = patientinfo.id_in_hospital;
          this.form.birthday = patientinfo.birthday === this.initialTime ? '' :
            moment(patientinfo.birthday).format('YYYY-MM-DD');
          this.form.age = patientinfo.age > -1 ? (patientinfo.age + '') : '';
          this.form.id_card_number = patientinfo.id_card_number;
          this.form.phone = patientinfo.phone;
          this.form.profession = patientinfo.profession;
          this.form.gender = patientinfo.gender;
          //console.log(this.form.gender)
            if (this.form.gender === "女") {
                this.position = Object.keys(raceJson.position.woman);
                this.figureObj = raceJson.position.woman;
            } else {
                this.position = Object.keys(raceJson.position.man);
                this.figureObj = raceJson.position.man;
            }

          this.form.name = patientinfo.name;
          this.form.race = patientinfo.race;
          this.form.skin_color = patientinfo.skin_color;
          this.form.skin_type = patientinfo.skin_type;
          this.form.address = patientinfo.address;
          this.form.idCardNumber = patientinfo.id_card_number;
          this.form.nativePlace = patientinfo.native_place;
          this.form.country = patientinfo.country;
          this.form.email = patientinfo.email;
          this.form.phone2 = patientinfo.phone2 || '';
          this.form.education = patientinfo.education || '';
          this.form.smoking = patientinfo.smoking || '';
          this.form.drinking = patientinfo.drinking || '';
          this.form.dietHabitArr = patientinfo.diet_habit ? patientinfo.diet_habit.split(',').filter(s => s) : [];
          this.form.diet_habit = patientinfo.diet_habit || '';
          this.form.height = patientinfo.height || '';
          this.form.weight = patientinfo.weight || '';
          this.form.note = patientinfo.note || '';
          this.patient_id = patientinfo.id;
          this.getHistoryCheckData();
          this.readonly = true;
          // this.isNewDiagnose = true;
          this.fromNewDiagnose = true;
          // 将诊断信息填上
          this.form2.id_in_hospital = diagnosisinfo.id_in_hospital;
          this.form2.applicant = diagnosisinfo.applicant;
          this.form2.applicant_unit = diagnosisinfo.applicant_unit;
          this.form2.review_doctor = diagnosisinfo.review_doctor;
          this.form2.unit = diagnosisinfo.unit;
          this.form2.fee = diagnosisinfo.fee ? String(diagnosisinfo.fee / 100) : '';
          this.form2.initial_conclusion = diagnosisinfo.initial_conclusion;
          this.form2.complaint = diagnosisinfo.complaint;
          this.form2.disease_history_present = diagnosisinfo.disease_history_present;
          this.form2.disease_history_before = diagnosisinfo.disease_history_before;
          this.form2.physical_examination = diagnosisinfo.physical_examination;
          this.form2.allergy_history = diagnosisinfo.allergy_history;
          this.form2.lab = diagnosisinfo.lab;
          this.form2.disease_history_family = diagnosisinfo.disease_history_family;
          this.diagnose_id_in_hospital = diagnosisinfo.id_in_hospital;
          this.diagnosisId = diagnosisinfo.id;
          this.form2.position_overview_list = diagnosisinfo.position_overview_list;
          this.form2.position_detail_list = diagnosisinfo.position_detail_list;
          this.otherDescription = diagnosisinfo.doctor_report;
          this.isCollection = diagnosisinfo.tagged;
          if (diagnosisinfo.position_detail_list) {
            const detailPositionArr = diagnosisinfo.position_detail_list.split(',');
            const choosedPosition = detailPositionArr.map(item => {
              return {
                active: false,
                detailPosition: item.split('-')[1],
                overviewPosition: item.split('-')[0],
              }
            });
            this.choosedPositionIndex = Math.max(0, choosedPosition.length - 1);
            choosedPosition[choosedPosition.length - 1].active = true;
            this.choosedPosition = choosedPosition;
          }
          if (diagnosisinfo.doctor_conclusion) {
            this.diagnoseResult = this.filterConclusion(diagnosisinfo.doctor_conclusion);
          }
          this.advise = diagnosisinfo.doctor_suggestion;
          // 将镜下所见数据传入
          this.reportText = {
            b_ultrasonic_report_text: diagnosisinfo.b_ultrasonic_report_text,
            ct_report_text: diagnosisinfo.ct_report_text,
            dermoscopy_report_text: diagnosisinfo.dermoscopy_report_text,
            pathology_report_text: diagnosisinfo.pathology_report_text,
            macro_report_text: diagnosisinfo.macro_report_text,
          }
          // 显示图片
          await this.loadImages();
          this.$store.commit('clearModifyDiagnosisId');
        } catch (error) {
          console.log(error)
        }
      },
      // 将最新一次填写的检查信息填上
      handleExamineInfo() {
        if (this.applyDoctors.length > 0) {
          // this.$set(this.form2, 'applicant', this.applyDoctors[this.applyDoctors.length - 1].value);
        }
        if (this.applyUnit.length > 0) {
          this.$set(this.form2, 'applicant_unit', this.applyUnit[this.applyUnit.length - 1].value);
        }
        if (this.review_doctor_cache.length > 0) {
          // this.$set(this.form2, 'review_doctor', this.review_doctor_cache[this.review_doctor_cache.length - 1].value)
        }
        if (this.check_unit.length > 0) {
          this.$set(this.form2, 'unit', this.check_unit[this.check_unit.length - 1].value)
        }
        if (this.feeList.length > 0) {
          this.$set(this.form2, 'fee', this.feeList[this.feeList.length - 1].value)
        }
      },
      refreshImages() {
        this.$root.$emit("refresh-diagnosis-images")
      },
      showMenu(bool) {
        this.isShowMenu = bool;
      },
      scrollLog(e) {
        if (this.isShowMenu) {
          this.scrollChange = !this.scrollChange;
          this.isShowMenu = false;
        }
      },
      async takePicture() {
        if (!this.isProcessing) { // 防止连续触发
          this.isProcessing = true;
          if (this.picType === 'dt') {
            await this.takePhotos(Util.GENERAL.code);
            this.isProcessing = false;
          } else if (this.picType === 'sk') {
            await this.takePhotos(Number(this.selectSkinType));
            this.isProcessing = false;
            window.localStorage.setItem('skinType', this.selectSkinType);
          }
        }
      },
      // 验证id是否重复（新）
      async verifyIdRepeat() {
        try {
          const res = await this.$apollo.query({
            query: gql`query(
              $id_in_hospital: String!
            ){
              getByIdInHospital(
                id_in_hospital: $id_in_hospital
              ){
                id
              }
            }`,
            fetchPolicy: "no-cache",
            variables: {
              id_in_hospital: this.form.id_in_hospital,
            },
          });
          if (res.data.getByIdInHospital.length) {
            this.$message.error('患者ID被占用，请核实后重新填写相关信息');
          } else {
            return true;
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 根据id和姓名匹配用户
      async verificationPatient() {
        if (this.form.id_in_hospital && this.form.name) {
          try {
            const res = await this.$apollo.query({
              query: gql`query(
                $id_in_hospital: String!
                $patient_name: String!
              ){
                isAccessPatient(
                  id_in_hospital: $id_in_hospital
                  patient_name: $patient_name
                ){
                  id
                  id_in_hospital
                  name
                  birthday
                  age
                  skin_color
                  skin_type
                  gender
                  phone
                  phone2
                  race
                  address
                  id_card_number
                  native_place
                  country
                  profession
                  email
                  education
                  smoking
                  drinking
                  diet_habit
                  height
                  weight
                  note
                  created_time
                }
              }`,
              fetchPolicy: "no-cache",
              variables: {
                id_in_hospital: this.form.id_in_hospital,
                patient_name: this.form.name,
              },
            });
            if (res.data.isAccessPatient.length) {
              const data = res.data.isAccessPatient[0];
              const dataForm = {
                id: data.id,
                // 患者id
                id_in_hospital: data.id_in_hospital,
                // 姓名
                name: data.name,
                birthday: data.birthday === this.initialTime ? '' : moment(data.birthday).format('YYYY-MM-DD'),
                age: data.age > -1 ? (data.age + '') : '',
                skin_color: data.skin_color,
                skin_type: data.skin_type,
                gender: data.gender,
                phone: data.phone,
                phone2: data.phone2 || '',
                // 民族
                race: data.race,
                // 地址
                address: data.address,
                // 身份证号
                idCardNumber: data.id_card_number,
                // 籍贯
                nativePlace: data.native_place,
                country: data.country,
                // 职业
                profession: data.profession,
                email: data.email,
                education: data.education || '',
                smoking: data.smoking || '',
                drinking: data.drinking || '',
                dietHabitArr: data.diet_habit ? data.diet_habit.split(',').filter(s => s) : [],
                diet_habit: data.diet_habit || '',
                height: data.height || '',
                weight: data.weight || '',
                note: data.note || '',
                created_time: data.created_time,
              };
              this.useID = true;
              this.isReset = true;
              this.readonly = true;
              this.fromNewDiagnose = true;
              this.form = dataForm;
              this.patient_id = data.id;
              // 将最近一次填写检查信息填写上
              this.handleExamineInfo();
              // 请求历史诊断列表
              this.getHistoryCheckData();
              // 重置form表单验证状态
              this.$refs.form.resetFields();
              this.$message({
                type: "success",
                message: "患者已登记，请继续填写病历信息",
              });
            } else {
              return await this.verifyIdRepeat();
            }
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
        }
      },
      // form
      patientForm() {
        setTimeout(async () => {
          const newval = this.form;
          if (!this.fromNewDiagnose) {
            if (this.patient_id !== "") {
              // 修改患者信息
              // 同步 dietHabitArr 到 diet_habit 字符串
              this.form.diet_habit = this.dietHabitArrToString();
              await this.modifySicker(newval);
            } else {
              // 进行匹配和查重
              const result = await this.verificationPatient();
              if (result) {
                // 新建患者
                if (
                  newval.id_in_hospital !== "" &&
                  newval.name !== "" &&
                  newval.gender !== "" &&
                  (newval.birthday || newval.age !== '')
                ) {
                  const obj = await this.patientIdRepeat(this.form.id_in_hospital);
                  if (!obj.id) {
                    // 同步 dietHabitArr 到 diet_habit 字符串
                    this.form.diet_habit = this.dietHabitArrToString();
                    let addRes = await this.addSicker(newval);
                    this.patient_id = addRes.data.addPatient.id;
                    this.form.id = addRes.data.addPatient.id;
                    this.getCreatedTime(addRes.data.addPatient.id);
                    this.$message({
                      type: "success",
                      message: "添加患者成功"
                    });
                    this.found = true;
                    this.patient_id_disabled = true;
                    // 将最近一次填写检查信息填写上
                    this.handleExamineInfo()
                    // 如果此时诊断信息填写完毕就进行诊断信息的提交
                    if (
                      this.form2.position_overview_list !== "" &&
                      this.form2.position_detail_list !== ""
                    ) {
                      await this.addDiagnosis();
                    }
                  }
                }
              }
            }
          }
          if (newval.gender === "女") {
            this.position = Object.keys(raceJson.position.woman);
            this.figureObj = raceJson.position.woman;
          } else {
            this.position = Object.keys(raceJson.position.man);
            this.figureObj = raceJson.position.man;
          }
        }, 300);
      },
      // 保存top5
      async saveTop5({data, isSaveBtn}) {
        let parentId = "";
        if (data.dis === true) {
          console.log(this.template.top5Knowledge)
          const top5Knowledge = this.template.top5Knowledge[this.diagnoseType];
          // 取父级id
          if (data.predefine === true) {
            parentId = data.id;
          } else {
            parentId = data.id.replace(/-\d+$/, "").replace(/^\w+-/, "");
          }
          const filterArr = top5Knowledge.filter(item => {
            return item.id === parentId;
          });
          if (filterArr.length > 0) {
            const obj = top5Knowledge[top5Knowledge.indexOf(filterArr[0])];
            if (obj.children.length >= 5) {
              obj.children.splice(4, 1);
            }
            // 判断是否已存在
            const filters = obj.children.filter(item => {
              return item.name === data.name;
            });
            if (filters.length > 0) {
              const index = obj.children.indexOf(filters[0]);
              obj.children.splice(index, 1);
            }
            obj.children.unshift(data);
          } else {
            top5Knowledge.push({
              id: parentId,
              children: [data]
            });
          }
        }
        // 镜下所见点击保存按钮后保存到模板
        if (isSaveBtn === true) {
          const type = this.diagnoseType + '_templates';
          const parentId = data.id.replace(/-\d+$/, "").replace(/^\w+-/, "");
          const findData = this.queryMyTemplateById(parentId);
          if (findData) {
            if (findData[type]) {
              findData[type].unshift(data.name)
            } else {
              findData[type] = [data.name]
            }
          }
        }
        // 上传自定义模板
        try {
          const templateString = JSON.stringify(this.template);
          const response = await this.$apollo.mutate({
            mutation: gql`
            mutation($template: String!) {
              doctorSaveTemplate(template: $template)
            }
          `,
            variables: {
              template: templateString
            }
          });
          if (response.data.doctorSaveTemplate === null) {
            this.$message({
              type: "success",
              message: "成功!"
            });
          }
          // tree重新加载
          if (isSaveBtn === true) {
            this.treeReload = !this.treeReload;
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 保存影像诊断
      saveConclusion(bool, ID, showTop1) {
        // 防止blur事件和selectedDisease重复触发本事件函数
        if (this.isTrigger) {
          return
        }
        this.isTrigger = true;
        if (this.diagnoseResult === '') {
          // 恢复状态
          this.isTrigger = false;
          return
        }
        setTimeout(async () => {
          if (this.diagnosisId === -1) {
            this.$message.error("请先添加检查部位！");
            this.diagnoseResult = '';
            // 恢复状态
            this.isTrigger = false;
          } else {
            const type = {
              dermoscopy: 'skinUnderMirror',
              ct: 'ctUnderMirror',
              b_ultrasonic: 'bcUnderMirror',
              pathology: 'blUnderMirror'
            }
            const isHaveReportText = this.diagnoseType && this.$store.state[type[this.diagnoseType]] !== '';
            const knowledgeDic = this.knowledgeDic;
            let id = "";
            // 是否是通过模板添加的
            if (!bool) {
              if (this.diagnoseResult !== "") {
                const findObj = this.queryMyTemplateByName(this.diagnoseResult);
                if (findObj) {
                  id = findObj.id;
                } else {
                  for (let key in knowledgeDic) {
                    if (knowledgeDic[key].name === this.diagnoseResult) {
                      id = key;
                    }
                  }
                  // if (id === "" && this.selectedDiagnose === false) {
                  //   this.$message.error("请填写与模板对应的名称！");
                  //   // 恢复状态
                  //   this.isTrigger = false;
                  //   return;
                  // }
                }
              }
            } else {
              id = ID;
            }
            this.diseaseid = id;
            if (showTop1 === "yes" && this.diagnoseType !== "" && !isHaveReportText) {
              // console.log(this.template.top5Knowledge)
              const top5Knowledge = this.template.top5Knowledge && this.template.top5Knowledge[
                this.diagnoseType
                ] || [];
              if (top5Knowledge.length > 0) {
                const filterArr = top5Knowledge.filter(item => {
                  return item.id === id;
                });
                if (filterArr.length > 0) {
                  this.editUnderMirror(filterArr[0].children[0]);
                } else {
                  // 如果有原始模板则添加原始模板
                  let filterObj = {};
                  const f = data => {
                    for (const item of data) {
                      if (item.id === id) {
                        filterObj = item;
                      } else {
                        if (item.children) {
                          f(item.children);
                        }
                      }
                    }
                  };
                  f(this.knowledgeData);
                  // 判断是否有原始模板
                  if (filterObj[this.diagnoseType + "_templates"]) {
                    this.editUnderMirror({
                      name: filterObj[this.diagnoseType + "_templates"][0]
                    });
                  } else {
                    // 没有原始模板的情况
                    this.editUnderMirror({
                      node: true
                    });
                  }
                }
              } else {
                // 如果有原始模板则添加原始模板
                let filterObj = {};
                const f = data => {
                  for (const item of data) {
                    if (item.id === id) {
                      filterObj = item;
                    } else {
                      if (item.children) {
                        f(item.children);
                      }
                    }
                  }
                };
                f(this.knowledgeData);
                // 判断是否有原始模板
                if (filterObj[this.diagnoseType + "_templates"]) {
                  this.editUnderMirror({
                    name: filterObj[this.diagnoseType + "_templates"][0]
                  });
                } else {
                  // 没有原始模板的情况
                  this.editUnderMirror({
                    node: true
                  });
                }
              }
            }
            // 上传修改影像诊断
            try {
              const res = await this.$apollo.mutate({
                mutation: gql`mutation(
                  $id: Int!
                  $doctor_conclusion: String
                ){
                  modifyDiagnosis(
                    id: $id
                    doctor_conclusion: $doctor_conclusion
                  )
                }`,
                variables: {
                  id: this.diagnosisId,
                  doctor_conclusion: this.diagnoseResult,
                },
              });
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
          }
          this.isTrigger = false;
        }, 300);
      },
      
      clearJXSJ() {
        this.$confirm("是否删除其他类下的镜下所见?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$store.commit("handleUnderMirror", {type: "skin", data: ""});
            this.$store.commit("handleUnderMirror", {
              type: "general",
              data: ""
            });
            this.$store.commit("handleUnderMirror", {type: "ct", data: ""});
            this.$store.commit("handleUnderMirror", {type: "bc", data: ""});
            this.$store.commit("handleUnderMirror", {type: "bl", data: ""});
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      // 双击点击的时候更改镜下所见内容
      editUnderMirror(data) {
        this.currentData = _.cloneDeep(data);
        if (data.node === true || data.second === true) {
          this.currentData.description = "";
        } else {
          this.currentData.description = data.name;
        }
        if (this.isGeneral) {
          this.$store.commit("handleUnderMirror", {
            type: "general",
            data: this.currentData.description
          });
        } else if (this.isCT) {
          this.$store.commit("handleUnderMirror", {
            type: "ct",
            data: this.currentData.description
          });
        } else if (this.isBC) {
          this.$store.commit("handleUnderMirror", {
            type: "bc",
            data: this.currentData.description
          });
        } else if (this.skin) {
          this.$store.commit("handleUnderMirror", {
            type: "skin",
            data: this.currentData.description
          });
        } else {
          this.$store.commit("handleUnderMirror", {
            type: "bl",
            data: this.currentData.description
          });
        }
      },
      // 接受Tree组件传出的自定义模板
      cloneTemplate(data) {
        // 处理放入knowledgeDic中
        this.template = _.cloneDeep(data);
        const knowledgeDic = this.knowledgeDic;
        if (data.second.length > 0) {
          for (let val of data.second) {
            if (val.children && val.children.length > 0) {
              for (let value of val.children) {
                knowledgeDic[value.id] = {
                  name: value.name
                };
              }
            }
          }
        }
        // 生成影像诊断筛选数据
        const allDiseaseArr = [];
        for (let key in knowledgeDic) {
          if (knowledgeDic.hasOwnProperty(key)) {
            allDiseaseArr.push({
              value: knowledgeDic[key].name,
              id: key
            });
          }
        }
        this.allDisease = allDiseaseArr;
      },
      // 取消右击默认事件
      prevent(e) {
        e.preventDefault();
      },
      // 生成检查编号
      async createDiagnoseId(data2) {
        const response = await this.$apollo.query({
          query: gql`{
            patient(id:${this.patient_id}){
              diagnoses{
                id
              }
            }
          }`,
          fetchPolicy: "no-cache"
        });
        if (this.form.id_in_hospital !== "") {
          data2.id_in_hospital =
            this.form.id_in_hospital +
            "-" +
            (response.data.patient.diagnoses.length + 1);
        } else {
          data2.id_in_hospital =
            this.patient_id + "-" + (response.data.patient.diagnoses.length + 1);
        }
        this.diagnose_id_in_hospital = data2.id_in_hospital;
      },
      // 检查患者id是否重复
      async patientIdRepeat(value) {
        const res = await this.$apollo.query({
          query: gql`query($keyword: String){
            patients(keyword: $keyword) {
              id
              name
              id_in_hospital
              gender
              birthday
              race
              skin_color
              skin_type
              address
              id_card_number
              native_place
              country
              profession
              email
              phone
            }
          }`,
          variables: {
            keyword: value,
          },
          fetchPolicy: "no-cache"
        });
        const arr = res.data.patients;
        const filterArr = arr.filter(item => {
          return item.id_in_hospital === value;
        });
        let obj = {};
        if (filterArr.length >= 1) {
          obj = filterArr[0];
        }
        return obj;
      },
      // id可选项
      async querySearchId(queryString, callback) {
        if (queryString !== "") {
          const res = await this.$apollo.query({
            query: gql`query($keyword: String){
                      patients(keyword: $keyword) {
                        id
                        name
                        id_in_hospital
                        gender
                        birthday
                        race
                        skin_color
                        skin_type
                        address
                        id_card_number
                        native_place
                        country
                        profession
                        email
                        phone
                        phone2
                        education
                        smoking
                        drinking
                        diet_habit
                        height
                        weight
                        note
                        age
                        created_time
                      }
                  }`,
            fetchPolicy: "no-cache",
            variables: {
              keyword: queryString,
            },
          });
          const arr = res.data.patients;
          const newArr = [];
          for (let i of arr) {
            newArr.push({
              value: `${i.id_in_hospital}`,
              form: {
                id: i.id,
                // 患者id
                id_in_hospital: i.id_in_hospital,
                // 姓名
                name: i.name,
                birthday: i.birthday === this.initialTime ? '' : moment(i.birthday).format('YYYY-MM-DD'),
                age: i.age > -1 ? (i.age + '') : '',
                skin_color: i.skin_color,
                skin_type: i.skin_type,
                gender: i.gender,
                phone: i.phone,
                phone2: i.phone2 || '',
                // 民族
                race: i.race,
                // 地址
                address: i.address,
                // 身份证号
                idCardNumber: i.id_card_number,
                // 籍贯
                nativePlace: i.native_place,
                country: i.country,
                // 职业
                profession: i.profession,
                email: i.email,
                education: i.education || '',
                smoking: i.smoking || '',
                drinking: i.drinking || '',
                dietHabitArr: i.diet_habit ? i.diet_habit.split(',').filter(s => s) : [],
                diet_habit: i.diet_habit || '',
                height: i.height || '',
                weight: i.weight || '',
                note: i.note || '',
                created_time: i.created_time,
              },
              id: i.id
            });
          }
          callback(newArr);
        }
      },
      // 选择了id
      handleSelectId(item) {
        this.useID = true;
        this.isReset = true;
        this.readonly = true;
        this.fromNewDiagnose = true;
        this.form = item.form;
        this.patient_id = item.id;
        // 将最近一次填写检查信息填写上
        this.handleExamineInfo();
        // 请求历史诊断列表
        this.getHistoryCheckData();
        // 重置form表单验证状态
        this.$refs.form.resetFields();
        this.$message({
          type: "success",
          message: "患者已登记，请继续填写病历信息",
        });
      },
      // 饮食习惯选择变更处理
      handleDietHabitChange(val) {
        if (val.includes('正常') && val.length > 1) {
          const lastItem = val[val.length - 1];
          if (lastItem === '正常') {
            this.form.dietHabitArr = ['正常'];
          } else {
            this.form.dietHabitArr = val.filter(v => v !== '正常');
          }
        }
      },
      // 饮食习惯数组转字符串
      dietHabitArrToString() {
        return this.form.dietHabitArr.join(',');
      },
      // 将逗号分隔字符串转为数组
      dietHabitStringToArr(str) {
        if (!str) return [];
        return str.split(',').filter(s => s);
      },
      // 保存建议
      async saveSuggestion() {
          const id = this.diagnosisId;
          if (id === -1) {
            // this.$message.error("请先添加检查部位！");
            return;
          }
          if (this.advise !== "") {
            try {
              await this.$apollo.mutate({
                mutation: gql`mutation($id: Int!, $doctor_suggestion: String){
                modifyDiagnosis(id: $id, doctor_suggestion: $doctor_suggestion)
              }`,
                variables: {
                  id,
                  doctor_suggestion: this.advise,
                }
              });
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
          }
      },
      async checkDiagnosis() {
        setTimeout(async () => {
          const form2Data = _.cloneDeep(this.form2);
          if (
            form2Data.position_overview_list !== "" &&
            form2Data.position_detail_list !== ""
          ) {
            this.cacheInputData("applyDoctors", form2Data);
            this.cacheInputData("applyUnit", form2Data);
            this.cacheInputData("reviewDoctorCache", form2Data);
            this.cacheInputData("checkUnit", form2Data);
            this.cacheInputData("fee", form2Data);
            if (!!this.diagnosisId && this.diagnosisId !== -1) {
              // 修改诊断信息
              form2Data.id_in_hospital = this.diagnose_id_in_hospital;
              await this.modifyDiagnosis(form2Data);
            } else {
              await this.createDiagnoseId(form2Data);
              this.form2.id_in_hospital = form2Data.id_in_hospital;
              let addRes = await this.postAddDiagnosis(form2Data);
              this.diagnosisId = addRes.data.addDiagnosis;
              // this.$message({
              //   type: "success",
              //   message: "添加诊断信息成功"
              // });
              this.hospital_id_disabled = true;
              let taggedRes = await this.$apollo.query({
                query: gql`
                query($id: Int!) {
                    diagnosis(id: $id) {
                      id
                      tagged
                    }
                  }
                `,
                variables: {
                  id: this.diagnosisId
                }
              });
              this.isCollection = taggedRes.data.diagnosis.tagged;
            }
          }
        }, 200);
      },
      // 递归将病名前面的数字去掉
      dealDiseaseName(obj) {
        if (obj.hasOwnProperty("children")) {
          let c = obj.children;
          for (let i = 0; i < c.length; i++) {
            c[i].name = c[i].name.replace(/^[0-9]+-/, "");
            this.dealDiseaseName(c[i]);
          }
        } else {
          obj.name = obj.name.replace(/^[0-9]+-/, "");
          if (obj.name !== "其他") {
            let j = {};
            j.value = obj.name;
            j.id = obj.id;
            this.allDisease.push(j);
          }
        }
      },
      // 打印组件发送来的信息
      printMessage(data) {
        let self = this;
        if (data.type === "back") {
          this.showPort = false;
          this.showSepPort = false;
        } else {
          this.showPort = false;
          this.showSepPort = true;
        }
      },
      // 新建患者
      newPatient() {
        this.newDiagnose();
        this.isNewDiagnose = true;
        this.$store.state.chooseItImgArr = [];
        this.$emit("message", {type: "newPatient"});
        this.useID = false;
        this.hospital_id_disabled = false;
        this.patient_id_disabled = false;
        this.found = false;
      },
      // 接受诊断记录子组件传递过来的值
      messagediagnoserecord(data) {
        switch (data.type) {
          case "close":
            this.showDiagnoseRecord = false;
            break;
          case "showIntell":
            this.detail_result = data.detail_result;
            this.imgList3 = data.imgList;
            this.resiltsVisible = true;
            break;
          case "large":
            this.showLargeImage = true;
            this.largeImage = data.src;
            break;
          case "importMedicalRecord":
            if (data.complaint) this.form2.complaint = data.complaint;
            if (data.initial_conclusion) this.form2.initial_conclusion = data.initial_conclusion;
            if (data.disease_history_present) this.form2.disease_history_present = data.disease_history_present;
            if (data.disease_history_before) this.form2.disease_history_before = data.disease_history_before;
            if (data.physical_examination) this.form2.physical_examination = data.physical_examination;
            if (data.allergy_history) this.form2.allergy_history = data.allergy_history;
            if (data.disease_history_family) this.form2.disease_history_family = data.disease_history_family;
            break;
          case "printreport":
            this.showSepPort = true;
            this.printreport_data = this.form;
            this.printreport_data2 = data.dinfo;
            this.printreport_images = data.data;
            this.printreport_isHostory = false;
            this.printreport_isDownLoad = data.isDownLoad;
            this.printreport_advise = data.advise;
            this.PrintSubmit();
            
            break;
        }
      },
      // 选择表格的某一行
      chooseTableItem(row, column, event) {
        this.choosedTableId = row.id;
        // 显示诊断记录弹窗
        this.showDiagnoseRecord = true;
        this.selectedDiagnosisType = row.diagnosisType;
      },
      filterNode(value, data) {
        if (!value) {
          return true;
        }
        return data.name.indexOf(value) !== -1;
      },
      // 点击百科
      async getContent(data) {
        this.currentData = data;
        let id = "";
        if (this.showInfo) {
          this.showInfo = false;
        }
        if (this.currentData.images) {
          for (let i = 0; i < this.currentData.images.length; i++) {
            this.imgList2[i] =
              api.knowledgeUrl + "/" + this.currentData.images[i];
          }
        } else {
          this.imgList2 = [];
        }
        // 如果是病名节点
        if (data.node === true) {
          this.diagnoseResult = this.currentData.name;
          this.editUnderMirror(data);
          id = data.id;
          // 病的id
          this.diseaseId = this.currentData.id;
        }
        // 如果是点击了亚型病种
        if (data.second === true) {
          this.diagnoseResult = data.name;
          this.editUnderMirror(data);
          id = data.id;
          // 病的id
          this.diseaseId = this.currentData.id;
        }
        // 如果是模板节点
        if (data.dis === true) {
          if (data.predefine === true) {
            // 如果是原始模板下的模板节点
            this.diagnoseResult = this.knowledgeDic[data.id].name;
            this.editUnderMirror(data);
            id = data.id;
          } else {
            // 如果是自定义下的模板节点
            // 上一级节点id
            const parentId = data.id.replace(/-\d+$/, "").replace(/^\w+-/, "");
            // 根据模板id获取病名
            this.diagnoseResult = this.filterConclusion(parentId);
            this.editUnderMirror(data);
            id = parentId;
          }
        }
        if (!this.currentData.children) {
          this.showInfo = true;
          this.showInfoDate = this.currentData;
        }
        // 上传保存影像诊断
        this.saveConclusion(true, id, "no");
        this.saveTop5({data, isSaveBtn: false});
      },
      // 取消删除该部位
      cancelDeletePosition() {
        this.deletePositionDialog = false;
      },
      // 确定删除该部位
      confirmDeletePosition() {
        this.choosedPosition.splice(this.deletePositionIndex, 1);
        if (this.deletePositionIndex < this.choosedPositionIndex) {
          this.choosedPositionIndex = Math.max(this.choosedPositionIndex - 1, 0);
        } else if (this.deletePositionIndex === this.choosedPositionIndex) {
          this.choosedPositionIndex = Math.max(this.choosedPosition.length - 1, 0);
          if (this.choosedPosition[this.choosedPositionIndex]) {
            this.choosedPosition[this.choosedPositionIndex].active = true;
          }
        }
        // 删除提交的表单中的相关参数
        const positionOverview = this.form2.position_overview_list.split(',');
        const index1 = positionOverview.findIndex(item => item === this.willDeletePosition.split('-')[0]);
        positionOverview.splice(index1, 1);
        this.form2.position_overview_list = positionOverview.join(',');
        const positionDetail = this.form2.position_detail_list.split(',');
        const index2 = positionDetail.findIndex(item => item === this.willDeletePosition);
        positionDetail.splice(index2, 1);
        this.form2.position_detail_list = positionDetail.join(',');
        this.checkDiagnosis();
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.deletePositionDialog = false;
      },
      // 显示检查部位一级菜单
      showCheckPosition() {
        this.checkoverview = true;
      },
      hideCheckPosition() {
        this.checkoverview = false;
      },
      showCheckPositionMax() {
        this.checkoverviewMax = true;
      },
      hideCheckPositionMax() {
        this.checkoverviewMax = false;
      },
      // 激活一级菜单的选项
      activeTopLevel(index) {
        this.topLevelIndex = index;
      },
      // 激活二级菜单的选项
      activeSecondLevel(event, index) {
        // 防止该事件冒泡
        event.cancelBubble = true;
        this.secondLevelIndex = index;
      },
      // 移动到已经选择的部位位置触发的事件
      moveOnChoosedPosition(index) {
        this.choosedPositionIndex = Math.max(index, 0);
        for (let i = 0; i < this.choosedPosition.length; i++) {
          if (i === index) {
            this.choosedPosition[i].active = true;
          } else {
            if (this.choosedPosition[i].active) {
              this.choosedPosition[i].active = false;
            }
          }
        }
        this.checkDiagnosis();
      },
      // 删除该部位
      deleteThePosition(event, overviewPosition, detailPosition, index) {
        this.deletePositionIndex = index;
        event.cancelBubble = true;
        this.willDeletePosition = overviewPosition + "-" + detailPosition;
        this.deletePositionDialog = true;
      },
      // 确定选择的
      ensureFigure(overviewPosition, detailPosition) {
        if (this.patient_id === "") {
          this.$message.error("请添加患者信息!!!");
          this.checkoverview = false;
          this.checkoverviewMax = false;
          return;
        }
        this.checkoverview = false;
        this.checkoverviewMax = false;
        let choosedJson = {};
        choosedJson.overviewPosition = overviewPosition;
        choosedJson.detailPosition = detailPosition;
        let exist = false;
        for (let i = 0, len = this.choosedPosition.length; i < len; i++) {
          if (
            this.choosedPosition[i].overviewPosition ===
            choosedJson.overviewPosition &&
            this.choosedPosition[i].detailPosition === choosedJson.detailPosition
          ) {
            this.$message.error("您已经选择该部位");
            exist = true;
          }
          this.choosedPosition[i].active = false;
        }
        if (!exist) {
          choosedJson.active = true;
          this.choosedPosition.push(choosedJson);
          this.overviewList.push(choosedJson.overviewPosition);
          this.detailList.push(
            choosedJson.overviewPosition + "-" + choosedJson.detailPosition
          );
          this.form2.position_overview_list = this.overviewList.toString();
          this.form2.position_detail_list = this.detailList.toString();
          // 如果是最后填的这一项就提交表单
          this.choosedPositionIndex = Math.max(this.choosedPosition.length - 1, 0);
          this.checkDiagnosis();
        }
        this.choosedPosition = _.uniqBy(this.choosedPosition, "detailPosition");
      },
      // 隐藏检查部位一级菜单
      hideCheckPostion() {
        this.checkoverview = false;
      },
      // 点击黄色按钮添加患者
      pushPatient() {
        // 将当前的患者数据清空
      },
      showPatientMore(params) {
        if (params === "show") {
          this.patientMore = false;
        } else {
          this.patientMore = true;
        }
      },
      showCheckMore(params) {
        if (params === "show") {
          this.checkMore = false;
        } else {
          this.checkMore = true;
        }
      },
      closeCamera() {
        this.isTakePhone = false;
        try {
          if (this.tracks[0]) {
            this.tracks[0].stop();
          }
        } catch (error) {
          console.log(error);
        }
      },
      // 偏振光拍摄
      async pz() {
        await this.takePhotos(Util.POLARRIZE.code);
      },
      async takePhotos(type) {
        if (this.diagnosisId === -1) {
          this.$message.error("请先添加检查部位！");
          return;
        }
        this.takePhotoLoading = true;
        let ctx = this.canvas.getContext("2d");
        ctx.drawImage(this.video, 0, 0, this.videoWidth, this.videoHeight);
        //console.log("In takePhotos, videoWidth, videoHeight:",this.videoWidth, this.videoHeight)
        // canvas图像转为图片
        let image = new Image();
        image.src = this.canvas.toDataURL("image/png",0.98);
        let base64ImgData = image.src.replace(
          /^data:image\/(jpeg|png|gif);base64,/,
          ""
        );
        let imgObjArr = [];
        let imgJson = {};
        imgJson.type = type;
        imgJson.base64 = base64ImgData;
        imgJson.ext = "jpg";
        imgJson.upload_mark = new Date().valueOf() + '_' + Math.floor(Math.random() * 1000);
        if (!!this.activePosition) {
          imgJson.position_overview = this.activePosition.overviewPosition;
          imgJson.position_detail =
            this.activePosition.overviewPosition +
            "-" +
            this.activePosition.detailPosition;
        } else {
          this.$message.error("请先添加检查部位");
        }
        if (
          imgJson.position_overview === undefined ||
          imgJson.position_detail === undefined
        ) {
          this.$message.error("请先添加检查部位");
          this.takePhotoLoading = false;
          return;
        }
        imgObjArr.push(imgJson);
        this.takePhotoLoading = false;
        this.isProcessing = false;
        this.videoFlashPlay();
        await this.upload(base64ImgData, imgObjArr);
        if (this.selectCamera) {
          window.localStorage.setItem('selectCamera', this.selectCamera);
        }
      },
      // 浸润光拍摄
      async jr() {
        await this.takePhotos(Util.SOAK.code);
      },
      
      // 所有上传图片的
      async upload(base64ImgData, imgObjArr) {
        let params = {
          diagnosis_id: this.diagnosisId,
          images: imgObjArr
        };
        if (!!params.diagnosis_id && !!params.images) {
          // 先显示缩略图
          this.$refs.collectionType.handleShowThumbnailImage(params.images);
          // 上传
          try {
            let uploadImgsResponse = await this.$apollo.mutate({
              // Query
              mutation: gql`
              mutation($diagnosis_id: Int!, $images: [ImageInput!]!) {
                addImages(diagnosis_id: $diagnosis_id, images: $images)
              }
            `,
              variables: {
                diagnosis_id: params.diagnosis_id,
                images: params.images
              }
            });
            this.$message({
              message: "上传图片成功",
              type: "success"
            });
          } catch (e) {
            this.$message.error('上传失败');
          }
        } else {
          this.$message.error("参数错误!");
        }
      },
      // 比较两张图的细节
      compare(data) {
        data.choosedImg = data.choosedImg.replace("thumbnails/", "");
        this.compareImgObj.choosedImg = data.choosedImg;
        this.compareImgObj.compareImg = data.compareImg;
        this.compareImgObj.similarity = data.similarity;
        this.compareImgObj.disease_desc = data.disease_desc;
        this.compareImgObj.isWidth1 = data.isWidth1;
        this.compareImgObj.isWidth2 = data.isWidth2;
        // this.resiltsVisible = false;
        this.compareDialog = true;
      },
      ...mapMutations(["add"]),
      chooseExistPatient() {
        // console.log("in chooseExistPatient form is ",this.form);
      },
      // 请求历史检查记录
      async getHistoryCheckData() {
        let historyRes = await this.$apollo.query({
          query: gql`
          query patient($id: Int!) {
            patient(id: $id) {
              id
              diagnoses {
                id
                applicant
                position_overview_list
                position_detail_list
                doctor_conclusion
                time
                id_in_hospital
                ct_report_images
                images {
                  id
                  type
                }
              }
              hospitalization{
                id
                update_time
                diagnosis
              }
              operation{
                id
                update_time
                operation_position
                relevant_info{
                  id
                  diagnosis
                }
                operation_releinfo_id
              }
               cosmetology{
                  id
                  update_time
                  diagnosis
                  treat_details{
                    id
                    item_info{
                      id
                      item_name
                    }
                  }
                }
            }
          }
        `,
          variables: {
            id: this.patient_id
          },
          fetchPolicy: "no-cache"
        });
        if (this.wordbook === null) {
          let res1 = await axios.request({
            method: "get",
            url: api.wordbook,
            headers: {
              "x-csrf-token": csrftoken
            },
            withCredentials: true
          });
          this.wordbook = res1.data;
        }
        this.diagnosesRecordList = historyRes.data.patient.diagnoses;
        const tableData1 = historyRes.data.patient.diagnoses
        const tableData2 = historyRes.data.patient.hospitalization;
        const tableData3 = historyRes.data.patient.operation;
        const tableData4 = historyRes.data.patient.cosmetology;
        for (let i = 0; i < tableData1.length; i++) {
          tableData1[i].diagnosisType = '影像';
          /*tableData1[i].time = moment(tableData1[i].time).format(
            "YYYY-MM-DD HH:mm"
          );*/
          tableData1[i].doctor_conclusion = this.filterConclusion(tableData1[i].doctor_conclusion);
          let imgs = tableData1[i].images;
          let typeArr = [];
          for (let j = 0; j < imgs.length; j++) {
            let typeString = "";
            switch (imgs[j].type) {
              case Util.SOAK.code:
                typeString = "皮肤镜";
                break;
              case Util.POLARRIZE.code:
                typeString = "皮肤镜";
                break;
              case Util.GENERAL.code:
                typeString = "大体图/伍德灯";
                break;
              case Util.CT.code:
                typeString = "CT";
                break;
              case Util.BC.code:
                typeString = "B超";
                break;
              case Util.PATHOlOGY.code:
                typeString = "病理";
                break;
            }
            typeArr.push(typeString);
          }
          typeArr = _.uniq(typeArr);
          tableData1[i].typeArr = typeArr.toString();
          if (
            tableData1[i].doctor_conclusion !== "" &&
            this.wordbook !== null
          ) {
            if (!!this.wordbook[tableData1[i].doctor_conclusion]) {
              tableData1[i].doctor_conclusion = this.wordbook[
                tableData1[i].doctor_conclusion
                ].name;
            }
          }
        }
        for (const item of tableData2) {
          item.diagnosisType = '住院';
          item.time = item.update_time;
          item.doctor_conclusion = this.filterConclusion(item.diagnosis);
          item.typeArr = '大体图'
        }
        for (const item of tableData3) {
          item.diagnosisType = '手术';
          item.time = item.update_time;
          item.doctor_conclusion = this.filterConclusion(item.relevant_info[0].diagnosis);
          item.position_detail_list = item.operation_position;
        }
        for (const item of tableData4) {
          item.diagnosisType = '美容/治疗';
          item.time = item.update_time;
          item.doctor_conclusion = this.filterConclusion(item.diagnosis);
          if (item.treat_details.length) {
            let text = '';
            for (const item1 of item.treat_details) {
              if (item1.item_info) {
                text += ('/' + item1.item_info.item_name);
              }
            }
            item.typeArr = text.substring(1);
          }
          item.date = moment(item.update_time).format('YYYYMMDD HH:mm:ss');
        }
        const tableData = tableData1.concat(tableData2, tableData3, tableData4);
        this.tableData = tableData.sort((a, b) => {
          return b.time - a.time;
        });
      },
      dealHistoryData(sourceData) {
        if (!!sourceData) {
          let dataLen = sourceData.length;
          for (let i = 0; i < sourceData.length; i++) {
            let tableItem = {};
            tableItem.index = sourceData[i].id;
            tableItem.historyIndex = sourceData[i].id;
            tableItem.historyDate =
              typeof sourceData[i] === "string"
                ? sourceData[i].time.slice(0, 10)
                : "";
            let positionNumber = Number(
              sourceData[i].position_overview + "" + sourceData[i].position_detail
            );
            tableItem.checkPosition = this.getDetailString(positionNumber);
            tableItem.checkResult = !!sourceData[i].doctor_conclusion
              ? sourceData[i].doctor_conclusion
              : "暂无结果";
            this.tableData.push(tableItem);
          }
        } else {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 取出具体的数字代表的大体部位
      getDetailString(detailNumber) {
        let dataArr = raceJson.options2;
        for (let i = 0, len = dataArr.length; i < len; i++) {
          for (let j = 0, leng = dataArr[i].length; j < leng; j++) {
            if (dataArr[i][j].value === detailNumber) {
              return dataArr[i][j].label;
            }
          }
        }
        return "";
      },
      // 获取摄像头组件传递进来的数据
      getCameraParams(message) {
        switch (message.type) {
          case "closeCamera":
            this.isTakePhone = false;
            break;
        }
      },
      // 接收来自子组件传来的值
      async getCollectionMessage(message) {
        switch (message.type) {
          // 智能搜图
          case "intelligentSearch":
            // this.diagnoseResult = "";
  
            /*   智能搜图暂时取消触发事件*/
            if (this.$store.state.controller.allowAiSearch === 1){
              await this.intelligentSubmit();
            }
     
            
            
            break;
          // 编辑图片
          case "detailResult":
            if (this.detail_result.length === 0) {
              this.$message.error(this.differentContent.errorCon);
              return;
            } else {
              this.resiltsVisible = true;
            }
            break;
          case "imgEditor":
            this.dialogVisible = true;
            let newData = {};
            newData.position_detail = message.position;
            newData.type = message.idType;
            newData.id = message.id;
            this.LookBigPhoto(message.imgSrc.replace(api.imageSrcPrefixThumbnails, ""), newData, this.form.id)
            this.currentImg = message.imgSrc;
            this.editImgId = message.id;
            this.currentType = message.idType;
            this.currentEditorIndex = message.index;
            // let dragTag = this.$refs.dragEditor;
            break;
          // 删除图片
          case "deleteImg":
            this.centerDialogVisible = true;
            this.deleteImgId = message.id;
            break;
          case "takePhone":
            this.picType = message.picType;
            await this.getCameraList();
            await this.showCamera();
            this.isTakePhone = true;
            this.$nextTick(() => {
              this.$refs.cameraCon.focus();
            });
            break;
          case "importReport":
            if (this.detail_result.length === 0) {
              this.$message.error(this.differentContent.errorCon);
              return;
            } else {
              let disease = message.data;
              this.diagnoseResult = disease.name;
              switch (message.mode) {
                case "sk":
                  this.skinReportObj.underMirror = message.data.description;
                  this.skinReportObj.name = message.data.name;
                  this.skinReportObj.reportImgs = message.reportImgs;
                  this.skinReportObj.position = message.position;
                  this.skinReportObj.mode = "皮肤镜";
                  // 发送给服务器数据信息
                  let importReportRes1 = await this.$apollo.mutate({
                    mutation: gql`mutation ($id: Int!){
                    modifyDiagnosis(id: $id,doctor_conclusion: "${
                      disease.code
                      }",doctor_suggestion: "${ad}",
                    dermoscopy_report_images: "${
                      disease.reportImgs
                      }",dermoscopy_report_text: "${disease.description}")
                  }`,
                    variables: {
                      id: this.diagnosisId
                    }
                  });
                  break;
              }
            }
            
            break;
        }
      },
      async intelligentSubmit() {
        let img = [];
        let choosedImg = _.cloneDeep(this.$store.state.chooseItImgArr);
        if (this.patient_id === "") {
          this.$message.error("请添加患者信息!!!");
          return;
        }
        if (this.diagnosisId === -1) {
          this.$message.error("请添加检查部位!!!");
          return;
        }
        if (choosedImg.length === 0) {
          this.$message.error("请最少选择一张图片");
          return;
        }
        if (choosedImg.length > 3) {
          this.$message.error("最多选择三张搜图图片!!!");
          return;
        }
        
        this.imgList3 = []; // 先清除详情结果图片数据
        for (let i = 0; i < choosedImg.length; i++) {
          img.push(choosedImg[i].id);
          this.imgList3.push(choosedImg[i].src);
        }
        let diagnosisId = this.diagnosisId;
        // 新的智能搜图请求方式
        try {
            await this.$apollo.mutate({
            mutation: gql`
            mutation(
              $diagnosis_id: Int!
              $image_ids: [Int!]!
              $asynchronous: Boolean
            ) {
              aiDiagnose(
                diagnosis_id: $diagnosis_id
                image_ids: $image_ids
                asynchronous: $asynchronous
              )
            }
          `,
            variables: {
              diagnosis_id: diagnosisId,
              image_ids: img,
              asynchronous: true
            },
            fetchPolicy: "no-cache"
          });
          this.disableIntell = true;
          this.loading = true;

          setTimeout(() => {
            if (this.loading && this.disableIntell) {
              this.loading = false;
              // 解禁按钮
              this.disableIntell = false;
              this.$message({
                message: "超时！请刷新页面后重试",
                type: "error"
              });
            }
          }, 10000);
        } catch (error) {
          this.loading = false;
          this.disableIntell = false;
          this.$message({
            message: "超时！请重试",
            type: "error"
          });
        }
      },
      // 激活tag
      activeOption(param, index) {
        switch (index) {
          case 1:
            this.isGeneral = false;
            this.isCT = false;
            this.isBC = false;
            this.skin = true;
            this.bl = false;
            break;
          case 0:
            this.skin = false;
            this.isCT = false;
            this.isBC = false;
            this.isGeneral = true;
            this.bl = false;
            break;
          case 2:
            this.skin = false;
            this.isGeneral = false;
            this.isBC = false;
            this.isCT = true;
            this.bl = false;
            break;
          case 3:
            this.isGeneral = false;
            this.isBC = true;
            this.isCT = false;
            this.skin = false;
            this.bl = false;
            break;
          case 4:
            this.isGeneral = false;
            this.isBC = false;
            this.skin = false;
            this.isCT = false;
            this.bl = true;
            break;
        }
        // 清空已经选择的图片
         this.$store.state.chooseItImgArr = [];
        for (let i = 0, len = this.tags.length; i < len; i++) {
          if (this.tags[i].text === param && i === index) {
            this.$set(this.tags[i], "checked", true);
          } else {
            if (this.tags[i].checked) {
              // this.tags[i].checked = false;
              this.$set(this.tags[i], "checked", false);
            }
          }
        }
        // 给tree组件传参
        if (this.isCT) {
          this.diagnoseType = "ct";
        }
        if (this.isBC) {
          this.diagnoseType = "b_ultrasonic";
        }
        if (this.skin) {
          this.diagnoseType = "dermoscopy";
        }
        if (this.bl) {
          this.diagnoseType = "pathology";
        }
        if (this.isGeneral) {
          this.diagnoseType = "";
        }
     /*   for (let i = 0;i<this.imgList.length;i++){
          this.imgList[i].pathName = this.imgList[i].path;
          this.imgList[i].pathS = `${api.server}/skin_images/thumbnails/${this.imgList[i].path}`;
          this.imgList[i].path = `${api.server}/skin_images/thumbnails/${this.imgList[i].path}`;
          this.imgList[i].checked = false;
          this.imgList[i].ext = "png";
        }*/
      },
      // 标记
      async mark() {
        let self = this;
        try {
          if (this.diagnosisId === -1) {
            this.$message.error("请先添加患者和添加检查部位！");
            return;
          }
          let collectionRes = await this.$apollo.mutate({
            mutation: gql`
            mutation($id: Int!, $tagged: Boolean) {
              modifyDiagnosis(id: $id, tagged: $tagged)
            }
          `,
            variables: {
              id: self.diagnosisId,
              tagged: !self.isCollection
            }
          });
          if (!self.isCollection) {
            self.isCollection = true;
            this.$message({
              type: "success",
              message: "收藏成功"
            });
          } else {
            self.isCollection = false;
            this.$message({
              type: "success",
              message: "取消收藏成功"
            });
          }
        } catch (e) {
          this.$message.error("收藏失败");
        }
      },
      // 新的诊断
      async newDiagnose() {
        this.clearPortData();
        this.isNewDiagnose = true;
        this.reloadCollection = false;
        this.$nextTick(() => {
          this.reloadCollection = true;
        });
        this.activeOption("大体图/伍德灯", 0);
        this.$store.state.chooseItImgArr = [];
        // 诊断预览结果置空
        this.overview_result = [];
        // 清空检查信息
        for (let key in this.form2) {
          if (this.form2.hasOwnProperty(key)) {
            this.form2[key] = "";
          }
        }
        this.diagnosisId = -1;
        this.choosedPosition = [];
        this.overviewList = [];
        this.detailList = [];
        this.choosedPositionIndex = 0;
        this.checkMore = true;
        this.imgList = [];
        this.advise = "";
        this.diagnoseResult = "";
        this.otherDescription = "";
        if (this.patient_id) {
          await this.getHistoryCheckData();
        }
        this.isShowStateIcon = false;
        this.hospital_id_disabled = false;
        this.$nextTick(() => {
          this.isShowStateIcon = true;
        });
      },
      // 加载所有图片
      async loadImages() {
        //console.log('-loadImages-')
        let self = this;
        try {
          let imgsRes = await this.$apollo.query({
            query: gql`
            query($id: Int!) {
              diagnosis(id: $id) {
                id
                images {
                  id
                  path
                  server
                  type
                  tagged
                  position_overview
                  position_detail
                  print_time
                  upload_mark
                  origin
                }
              }
            }
          `,
            variables: {
              id: self.diagnosisId
            },
            fetchPolicy: "no-cache"
          });
          
       
    
          
          let images = [];
          let newRes = imgsRes.data.diagnosis.images;
          images = newRes.map((v,index) => {
            const newV = _.cloneDeep(v);
            newV.pathName = v.path;
            newV.pathS = `${api.server}/skin_images/thumbnails/${v.path}`;
           /* newV.path = 'data:image/jpeg;base64,' + v.strbase64;*/
            newV.path = `${api.server}/skin_images/thumbnails/${v.path}`;
            newV.checked = false;
            newV.ext = "png";
            return newV;
          });
          
          
          // let images = imgsRes.data.diagnosis.images.map(v => {
          //   if (v.path) {
          //     v.path = `${api.server}/skin_images/thumbnails/${v.path}`;
          //   }
          //   v.type = v.type;
          //   v.checked = false;
          //   v.ext = "png";
          //   v.tagged = v.tagged;
          //   v.id = v.id;
          //   v.position_overview = v.position_overview;
          //   v.position_detail = v.position_detail;
          //   return v;
          // });
          
          // 将打印过的图片处理成选中状态
          if (this.$store.state.modifyDiagnosisData.isModify) {
            // 如果是点击编辑跳转过来就执行
            const printTimeArr = images.map((item) => item.print_time);
            const maxDate = Math.max(...printTimeArr);
            if (maxDate !== this.initialTime) {
              // const filterArr = images.filter((item) => item.print_time === maxDate);
              for (const item of images) {
                if (item.print_time === maxDate) {
                  //console.log('ceshu')
                  item.isPrint = true;
                  this.$store.commit("pushItImgArrSkin", {
                    src: item.path,
                    id: item.id
                  });
                  this.$refs.collectionType.dbclickAdd({
                    target: {
                      src: item.path,
                    }
                  }, item);
                }
              }
            }
          }
          // this.imgList = images;
          // 更新显示
  
          for (const item of images) {
            const findIndex = this.imgList.findIndex(
              (item1) => item1.upload_mark === item.upload_mark);
            if (this.imgList[findIndex]) {
              if (!this.imgList[findIndex].id) {
                this.imgList.splice(findIndex, 1, item);
              }else if(this.imgList[findIndex].id){
                 if (this.imgList[findIndex].id === item.id){
                   this.imgList.splice(findIndex, 1, item);
                 }
              }
            } else {
              this.imgList.push(item);
            }
          }
          const findIndex = this.imgList.findIndex((item1) => item1.id === this.deleteImageId);
          if (findIndex > -1) {
            this.imgList.splice(findIndex, 1);
          }
        
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 请求添加病人
      async addSicker(params) {
        let response = await this.$apollo.mutate({
          // Query
          mutation: gql`mutation(
            $id_in_hospital: String!
            $name: String!
            $gender: String!
            $birthday: String!
            $race: String!
            $skin_color: String!
            $skin_type: String!
            $phone: String!
            $address: String!
            $id_card_number: String!
            $native_place: String!
            $country: String!
            $profession: String!
            $email: String!
            $age: Int
            $phone2: String
            $education: String
            $smoking: String
            $drinking: String
            $diet_habit: String
            $height: Float
            $weight: Float
            $note: String
          ){
          addPatient(
             id_in_hospital: $id_in_hospital,
             name: $name,
             gender: $gender,
             birthday: $birthday,
             race: $race,
             skin_color: $skin_color,
             skin_type: $skin_type,
             phone: $phone,
             address: $address,
             id_card_number: $id_card_number,
             native_place: $native_place,
             country: $country,
             profession: $profession,
             email: $email,
             age: $age,
             phone2: $phone2,
             education: $education,
             smoking: $smoking,
             drinking: $drinking,
             diet_habit: $diet_habit,
             height: $height,
             weight: $weight,
             note: $note
             ){
               id
             }
          }`,
          variables: {
            id_in_hospital: params.id_in_hospital,
            name: params.name,
            gender: params.gender,
            birthday: params.birthday ? params.birthday : moment(this.initialTime).format('YYYY-MM-DD'),
            race: params.race,
            skin_color: params.skin_color,
            skin_type: params.skin_type,
            phone: params.phone,
            address: params.address,
            id_card_number: params.idCardNumber,
            native_place: params.nativePlace,
            country: params.country,
            profession: params.profession,
            email: params.email,
            age: params.age ? Number(params.age) : -1,
            phone2: params.phone2 || null,
            education: params.education || null,
            smoking: params.smoking || null,
            drinking: params.drinking || null,
            diet_habit: params.diet_habit || null,
            height: params.height ? Number(params.height) : null,
            weight: params.weight ? Number(params.weight) : null,
            note: params.note || null,
          },
        });
        return response;
      },
      // 添加患者
      async handleClick(tab, event) {
        let formData = this.form;
        if (
          formData.birthday === "" ||
          formData.gender === "" ||
          formData.id_in_hospital === "" ||
          formData.name === "" ||
          formData.phone === "" ||
          formData.skin_color === ""
        ) {
          this.$message.error("请填写基本信息!!");
        } else {
          let reg = /^1\d{10}/;
          if (!reg.test(formData.phone)) {
            this.$message.error("手机号码不合法请重新填写手机号");
            return;
          }
          let response;
          if (this.patient_id !== "") {
            // 说明已经添加过诊断只需要修改就行了
            await this.modifySicker(formData);
          }
        }
      },
      // 修改患者信息
      async modifySicker(formData) {
        if (
          formData.id_in_hospital !== "" &&
          formData.name !== "" &&
          formData.gender !== "" &&
          (formData.birthday || formData.age !== '')
        ) {
          let res;
          let pid = this.patient_id;
          res = await this.$apollo.mutate({
            mutation: gql`mutation (
              $id: Int!
              $id_in_hospital: String
              $name: String
              $gender: String
              $birthday: String
              $race: String
              $skin_color: String
              $skin_type: String
              $phone: String
              $address: String
              $id_card_number: String
              $native_place: String
              $country: String
              $profession: String
              $email: String
              $age: Int
              $phone2: String
              $education: String
              $smoking: String
              $drinking: String
              $diet_habit: String
              $height: Float
              $weight: Float
              $note: String
            ){
              modifyPatient(
                id: $id,
                age: $age,
                id_in_hospital: $id_in_hospital,
                name: $name,
                gender: $gender,
                birthday: $birthday,
                race: $race,
                skin_color: $skin_color,
                skin_type: $skin_type,
                phone: $phone,
                address: $address,
                id_card_number: $id_card_number,
                native_place: $native_place,
                country: $country,
                profession: $profession,
                email: $email,
                phone2: $phone2,
                education: $education,
                smoking: $smoking,
                drinking: $drinking,
                diet_habit: $diet_habit,
                height: $height,
                weight: $weight,
                note: $note
              )
            }`,
            variables: {
              id: pid,
              id_in_hospital: formData.id_in_hospital,
              name: formData.name,
              gender: formData.gender,
              birthday: formData.birthday ? formData.birthday : moment(this.initialTime).format('YYYY-MM-DD'),
              race: formData.race,
              skin_color: formData.skin_color,
              skin_type: formData.skin_type,
              phone: formData.phone,
              address: formData.address,
              id_card_number: formData.idCardNumber,
              native_place: formData.nativePlace,
              country: formData.country,
              profession: formData.profession,
              email: formData.email,
              age: formData.age ? Number(formData.age) : -1,
              phone2: formData.phone2 || null,
              education: formData.education || null,
              smoking: formData.smoking || null,
              drinking: formData.drinking || null,
              diet_habit: formData.diet_habit || null,
              height: formData.height ? Number(formData.height) : null,
              weight: formData.weight ? Number(formData.weight) : null,
              note: formData.note || null,
            },
            fetchPolicy: "no-cache"
          });
        }
      },
      // 添加诊断信息
      async addDiagnosis() {
        setTimeout(async () => {
          const form2Data = _.cloneDeep(this.form2);
          if (
            form2Data.position_overview_list !== "" &&
            form2Data.position_detail_list !== ""
          ) {
            this.cacheInputData("applyDoctors", form2Data);
            this.cacheInputData("applyUnit", form2Data);
            this.cacheInputData("reviewDoctorCache", form2Data);
            this.cacheInputData("checkUnit", form2Data);
            this.cacheInputData("fee", form2Data);
            if (!!this.diagnosisId && this.diagnosisId !== -1) {
              // 修改诊断信息
              form2Data.id_in_hospital = this.diagnose_id_in_hospital;
              await this.modifyDiagnosis(form2Data);
            } else {
              if (this.patient_id === "") {
                this.$message.error("请先填写患者信息!!");
                return;
              }
              await this.createDiagnoseId(form2Data);
              this.form2.id_in_hospital = form2Data.id_in_hospital;
              let addRes = await this.postAddDiagnosis(form2Data);
              this.diagnosisId = addRes.data.addDiagnosis;
              this.$message({
                type: "success",
                message: "添加诊断信息成功"
              });
              this.hospital_id_disabled = true;
              let taggedRes = await this.$apollo.query({
                query: gql`
                  query($id: Int!) {
                    diagnosis(id: $id) {
                      id
                      tagged
                    }
                  }
                `,
                variables: {
                  id: this.diagnosisId
                }
              });
              this.isCollection = taggedRes.data.diagnosis.tagged;
            }
          }
        }, 200);
      },
      // 缓存输入数据
      cacheInputData(type, form2Data) {
        if (!!localStorage.getItem(type)) {
          // 取出数据解析成json数据
          let applyDoctorsStorage = JSON.parse(localStorage.getItem(type));
          let allowPush = true;
          let allowPushU = true;
          let allowPushR = true;
          let allowPushUn = true;
          let allowPushF = true;
          for (let i = 0; i < applyDoctorsStorage.length; i++) {
            switch (type) {
              case "applyDoctors":
                if (
                  applyDoctorsStorage[i].value === form2Data.applicant &&
                  applyDoctorsStorage[i].label === form2Data.applicant
                ) {
                  allowPush = false;
                }
                break;
              case "applyUnit":
                if (
                  applyDoctorsStorage[i].value === form2Data.applicant_unit &&
                  applyDoctorsStorage[i].label === form2Data.applicant_unit
                ) {
                  allowPushU = false;
                }
                break;
              case "reviewDoctorCache":
                if (
                  applyDoctorsStorage[i].value === form2Data.review_doctor &&
                  applyDoctorsStorage[i].label === form2Data.review_doctor
                ) {
                  allowPushR = false;
                }
                break;
              case "checkUnit":
                if (
                  applyDoctorsStorage[i].value === form2Data.unit &&
                  applyDoctorsStorage[i].label === form2Data.unit
                ) {
                  allowPushUn = false;
                }
                break;
              case "fee":
                if (
                  applyDoctorsStorage[i].value === form2Data.fee &&
                  applyDoctorsStorage[i].label === form2Data.fee
                ) {
                  allowPushF = false;
                }
                break;
            }
          }
          let dataJson = {};
          switch (type) {
            case "applyDoctors":
              if (form2Data.applicant !== "") {
                dataJson.value = form2Data.applicant;
                dataJson.label = form2Data.applicant;
                this.applyDoctors = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPush &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
            case "applyUnit":
              if (form2Data.applicant_unit !== "") {
                dataJson.value = form2Data.applicant_unit;
                dataJson.label = form2Data.applicant_unit;
                this.applyUnit = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPushU &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
            case "reviewDoctorCache":
              if (form2Data.review_doctor !== "") {
                dataJson.value = form2Data.review_doctor;
                dataJson.label = form2Data.review_doctor;
                this.review_doctor_cache = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPushR &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
            case "checkUnit":
              if (form2Data.unit !== "") {
                dataJson.value = form2Data.unit;
                dataJson.label = form2Data.unit;
                this.check_unit = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPushUn &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
            case "fee":
              if (form2Data.fee !== "0.00") {
                dataJson.value = form2Data.fee;
                dataJson.label = form2Data.fee;
                this.feeList = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPushF &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
          }
        } else {
          let arr = [];
          let dataJson = {};
          switch (type) {
            case "applyDoctors":
              if (form2Data.applicant !== "") {
                dataJson.value = form2Data.applicant;
                dataJson.label = form2Data.applicant;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
            case "applyUnit":
              if (form2Data.applicant_unit !== "") {
                dataJson.value = form2Data.applicant_unit;
                dataJson.label = form2Data.applicant_unit;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
            case "reviewDoctorCache":
              if (form2Data.review_doctor !== "") {
                dataJson.value = form2Data.review_doctor;
                dataJson.label = form2Data.review_doctor;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
            case "checkUnit":
              if (form2Data.unit !== "") {
                dataJson.value = form2Data.unit;
                dataJson.label = form2Data.unit;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
            case "fee":
              if (form2Data.fee !== "0.00") {
                dataJson.value = form2Data.fee;
                dataJson.label = form2Data.fee;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
          }
        }
      },
      // 提交诊断信息数据
      async postAddDiagnosis(data) {
        // 防止重复提交
        if (this.diagnosisId === -1) {
          if (typeof data.fee !== "number") {
            data.fee = Number(data.fee);
          }
          if (this.patient_id === "") {
            this.$message.error("请先添加患者!!!");
            return;
          }
          let patientId = this.patient_id;
          try {
            let response = await this.$apollo.mutate({
              // Query
              mutation: gql`mutation(
                $patient_id: Int!,
                $applicant: String,
                $applicant_unit: String,
                $fee: Int,
                $review_doctor: String,
                $unit: String,
                $initial_conclusion: String,
                $lab: String,
                $id_in_hospital: String,
                $position_overview_list: String!,
                $position_detail_list: String!,
                $complaint: String,
                $disease_history_present: String,
                $disease_history_before: String,
                $physical_examination: String,
                $allergy_history: String,
                $disease_history_family: String,
                $selected_position: String!
              ){
                addDiagnosis(
                  patient_id: $patient_id,
                  applicant: $applicant,
                  applicant_unit: $applicant_unit,
                  fee: $fee,
                  review_doctor: $review_doctor,
                  unit: $unit,
                  initial_conclusion: $initial_conclusion,
                  lab: $lab,
                  id_in_hospital: $id_in_hospital,
                  position_overview_list: $position_overview_list,
                  position_detail_list: $position_detail_list,
                  complaint: $complaint,
                  disease_history_present: $disease_history_present,
                  disease_history_before: $disease_history_before,
                  physical_examination: $physical_examination,
                  allergy_history: $allergy_history,
                  disease_history_family: $disease_history_family,
                  selected_position: $selected_position
                )
              }`,
              variables: {
                fee: Math.floor(data.fee * 100),
                patient_id: patientId,
                applicant: data.applicant,
                applicant_unit: data.applicant_unit,
                review_doctor: data.review_doctor,
                unit: data.unit,
                initial_conclusion: data.initial_conclusion,
                id_in_hospital: data.id_in_hospital,
                position_overview_list: data.position_overview_list,
                position_detail_list: data.position_detail_list,
                complaint: data.complaint,
                disease_history_present: data.disease_history_present,
                disease_history_before: data.disease_history_before,
                physical_examination: data.physical_examination,
                allergy_history: data.allergy_history,
                disease_history_family: data.disease_history_family,
                selected_position: data.position_detail_list,
              }
            });
            this.$message({
              type: "success",
              message: "添加诊断信息成功"
            });
            this.hospital_id_disabled = true;
            return response;
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
            return null;
          }
        }
      },
      // 修改诊断信息
      async modifyDiagnosis(data) {
        let copyData = _.cloneDeep(data);
        let selected_position = '';
        if (this.choosedPosition.length) {
          const position = this.choosedPosition[this.choosedPositionIndex];
          selected_position = position.overviewPosition + '-' + position.detailPosition;
        }
        try {
          let diagnose_id = this.diagnosisId;
          if (typeof copyData.fee !== "number") {
            copyData.fee = Number(copyData.fee);
          }
          let response = await this.$apollo.mutate({
            // Query
            mutation: gql`mutation (
              $id: Int!,
              $fee: Int,
              $applicant: String,
              $applicant_unit: String,
              $review_doctor: String,
              $unit: String,
              $initial_conclusion: String,
              $id_in_hospital: String,
              $position_overview_list: String,
              $position_detail_list: String,
              $lab: String,
              $complaint: String,
              $disease_history_present: String,
              $disease_history_before: String,
              $physical_examination: String,
              $allergy_history: String,
              $disease_history_family: String,
              $selected_position: String
            ){
              modifyDiagnosis(
                id: $id,
                fee: $fee,
                applicant: $applicant,
                applicant_unit: $applicant_unit,
                review_doctor: $review_doctor,
                unit: $unit,
                initial_conclusion: $initial_conclusion,
                id_in_hospital: $id_in_hospital,
                position_overview_list: $position_overview_list,
                position_detail_list: $position_detail_list,
                lab: $lab,
                complaint: $complaint,
                disease_history_present: $disease_history_present,
                disease_history_before: $disease_history_before,
                physical_examination: $physical_examination,
                allergy_history: $allergy_history,
                disease_history_family: $disease_history_family,
                selected_position: $selected_position
              )
            }`,
            variables: {
              id: diagnose_id,
              fee: Math.floor(copyData.fee * 100),
              applicant: data.applicant,
              applicant_unit: data.applicant_unit,
              review_doctor: data.review_doctor,
              unit: data.unit,
              initial_conclusion: data.initial_conclusion,
              id_in_hospital: data.id_in_hospital,
              position_overview_list: data.position_overview_list,
              position_detail_list: data.position_detail_list,
              lab: data.lab,
              complaint: data.complaint,
              disease_history_present: data.disease_history_present,
              disease_history_before: data.disease_history_before,
              physical_examination: data.physical_examination,
              allergy_history: data.allergy_history,
              disease_history_family: data.disease_history_family,
              selected_position,
            }
          });
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 拍摄相片
      photograph() {
        if (this.$refs.myVideo.srcObject !== null) {
          this.$refs.myCanvas
            .getContext("2d")
            .drawImage(this.$refs.myVideo, 0, 0, 600, 450);
          this.imgList.push({
            base64: this.$refs.myCanvas.toDataURL("image/jpg",0.98),
            checked: false,
            ext: "jpg"
          });
        }
      },
      showEdit(index) {
        this.currentIndex = index;
      },
      hidEdit() {
        this.currentIndex = -1;
        this.currentIndex2 = -1;
      },
      hidEdit2() {
        this.currentIndex2 = -1;
      },
      editHandler(imgSrc, num, id) {
        this.currentImg = imgSrc;
        this.currentType = num;
        this.editImgId = id;
        this.dialogVisible = true;
      },
      setImg() {
        this.$refs.mychild.getImgSrc(this.currentImg);
      },
      closeEdit() {
        this.dialogVisible = false;
      },
      async getImgSrc(data) {
        let base64 = data.imgData.replace(
          /^data:image\/(jpeg|png|gif);base64,/,
          ""
        );
        try {
          let deleteRes = await this.$apollo.mutate({
            mutation: gql`
            mutation($id: Int!, $tagged: Int!, $base64: String!) {
              modifyImage(id: $id, tagged: $tagged, base64: $base64)
            }
          `,
            variables: {
              id: this.editImgId,
              tagged: this.currentImg.tagged ? 1 : 0,
              base64
            }
          });
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.$store.commit("setEditImgSrc", data.currentImg.path);
        } catch (e) {
          this.$message.error("上传失败");
        }
        this.dialogVisible = false;
      },
      closeResult() {
        this.resiltsVisible = false;
      },
      async showPrint(isDownLoad) {

        // 打印方式样例
        try {
          
          let self = this;
          this.newDownLoad = isDownLoad;
          // 给服务器发送报告及镜下所见和图片索引
          if (this.patient_id === "") {
            this.$message.error("请添加患者信息!!!");
            return;
          }
          if (this.diagnosisId === -1) {
            this.$message.error("没有添加检查部位，无法生成报告");
            return;
          }
          let timeRes = await this.$apollo.query({
            query: gql`
          query($id: Int!) {
            diagnosis(id: $id) {
              id
              time
              doctor_conclusion
            }
          }
        `,
            variables: {
              id: this.diagnosisId
            }
          });
          let conclusion = timeRes.data.diagnosis.doctor_conclusion;
          let time = moment(timeRes.data.diagnosis.time).format("YYYY-MM-DD HH:mm");
          this.reportObj.skin = {};
          this.reportObj.skin.imgs = this.$store.state.skinReportImgs;
          let skinIds = this.installImgsId(this.reportObj.skin.imgs).toString();
          this.reportObj.skin.underMirror = this.$store.state.skinUnderMirror;
          this.reportObj.general = {};
          this.reportObj.general.imgs = this.$store.state.generalReportImgs;
          let generalIds = this.installImgsId(
            this.reportObj.general.imgs
          ).toString();
          this.reportObj.general.underMirror = this.$store.state.generalUnderMirror;
          this.reportObj.ct = {};
          this.reportObj.ct.imgs = this.$store.state.ctReportImgs;
          let ctIds = this.installImgsId(this.reportObj.ct.imgs).toString();
          this.reportObj.ct.underMirror = this.$store.state.ctUnderMirror;
          this.reportObj.bc = {};
          this.reportObj.bc.imgs = this.$store.state.bcReportImgs;
          let bcIds = this.installImgsId(this.reportObj.bc.imgs).toString();
          this.reportObj.bc.underMirror = this.$store.state.bcUnderMirror;
          this.reportObj.bl = {};
          this.reportObj.bl.imgs = this.$store.state.blReportImgs;
          let blIds = this.installImgsId(this.reportObj.bl.imgs).toString();
          this.reportObj.bl.underMirror = this.$store.state.blUnderMirror;
          let diseaseR;
          if (this.allDisease) {
            diseaseR = this.allDisease.filter(ele => {
              if (ele.value === self.diagnoseResult) {
                return ele;
              } else {
                return "";
              }
            });
          } else {
            diseaseR = [];
          }
          this.reportObj.diagnoseResult = self.diagnoseResult;
          this.reportObj.time = time;
          let otherDescription = this.otherDescription;
          this.reportObj.otherDes = otherDescription;
          let reportobject = this.reportObj;
          let bingId = "";
          if (!!diseaseR && diseaseR.length > 0) {
            bingId = diseaseR[0].id;
          } else {
            bingId = "";
          }
          // 修改诊断信息
          let modifyRes = await this.$apollo.mutate({
            mutation: gql`mutation (
            $id: Int!,
            $dermoscopy_report_images: String,
            $dermoscopy_report_text: String,
            $macro_report_images: String,
            $macro_report_text: String,
            $ct_report_images: String,
            $ct_report_text: String,
            $b_ultrasonic_report_images: String,
            $b_ultrasonic_report_text: String,
            $pathology_report_images: String,
            $pathology_report_text: String,
            $doctor_conclusion: String,
            $doctor_report: String
          ){
            modifyDiagnosis(
              id: $id,
              dermoscopy_report_images: $dermoscopy_report_images,
              dermoscopy_report_text: $dermoscopy_report_text,
              macro_report_images: $macro_report_images,
              macro_report_text: $macro_report_text,
              ct_report_images: $ct_report_images,
              ct_report_text: $ct_report_text,
              b_ultrasonic_report_images: $b_ultrasonic_report_images,
              b_ultrasonic_report_text: $b_ultrasonic_report_text,
              pathology_report_images: $pathology_report_images,
              pathology_report_text: $pathology_report_text,
              doctor_conclusion: $doctor_conclusion,
              doctor_report: $doctor_report
            )
          }`,
            variables: {
              id: this.diagnosisId,
              dermoscopy_report_images: skinIds,
              dermoscopy_report_text: reportobject.skin.underMirror,
              macro_report_images: generalIds,
              macro_report_text: reportobject.general.underMirror,
              ct_report_images: ctIds,
              ct_report_text: reportobject.ct.underMirror,
              b_ultrasonic_report_images: bcIds,
              b_ultrasonic_report_text: reportobject.bc.underMirror,
              pathology_report_images: blIds,
              pathology_report_text: reportobject.bl.underMirror,
              // doctor_conclusion: bingId,
              doctor_report: otherDescription,
            }
          });
          // this.showPort = true;
          this.printreport_data = this.form;
          this.printreport_data2 = this.form2;
          this.printreport_images = this.reportObj;
          this.printreport_isHostory = true;
          this.printreport_isDownLoad = isDownLoad;
          this.printreport_advise = this.advise;
          this.PrintSubmit();
        } catch (error) {
          if (error.message.split(":")[1] === ' Failed to fetch') {
            this.$message.error("网络异常，请检查网络!");
          } else {
            this.$message.error(error.message.split(":")[1]);
          }
        }
      },
      installImgsId(imgs) {
        let ids = [];
        if (!!imgs) {
          for (let i = 0; i < imgs.length; i++) {
            ids.push(imgs[i].id);
          }
        }
        ids = _.uniq(ids);
        return ids;
      },
      deleteImg(index, id) {
        this.deleteImgIndex = index;
        this.deleteImgId = id;
        this.centerDialogVisible = true;
      },
      // 确认删除
      async confirmDeletion() {
        this.deleteImageId = this.deleteImgId;
        let ids = [];
        ids.push(this.deleteImgId);
        let params = {
          diagnosis_id: this.diagnosisId,
          ids
        };
        try {
          let deleteRes = await this.$apollo.mutate({
            mutation: gql`
            mutation($diagnosis_id: Int!, $ids: [Int!]!) {
              removeImages(diagnosis_id: $diagnosis_id, ids: $ids)
            }
          `,
            variables: {
              diagnosis_id: params.diagnosis_id,
              ids: params.ids
            }
          });
          if (deleteRes.data.removeImages) {
            this.$store.commit("popItImgArr", {
              id: this.deleteImgId
            });
            this.$message({
              type: "success",
              message: "删除图片成功"
            });
          }
          this.centerDialogVisible = false;
          for (let i = 0; i < this.checkedIndex.length; i++) {
            if (this.checkedIndex[i] === this.deleteImgIndex) {
              this.checkedIndex.splice(i, 1);
            }
            if (index < this.checkedIndex[i]) {
              this.checkedIndex.splice(i, 1, this.checkedIndex[i] - 1);
            }
          }
        } catch (e) {
          this.$message.error("删除图片失败！");
        }
      },
      removeImg(index) {
        this.imgList2.splice(index, 1);
        this.report_images.splice(index, 1);
      },
      showRemove(index) {
        this.currentIndex2 = index;
      },
      incorrect() {
        this.isCorrect = true;
      },
      queryDisease(queryString, cb) {
        const restaurants = this.allDisease;
        const results = queryString
          ? restaurants.filter(this.filterDisease(queryString))
          : restaurants;
        const arr = [];
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (!data[i].children && data[i].id !== '1' && data[i].id !== '2' && data[i].id !== '3' && data[i].id !== '4' && data[i].id !== '5' && !data[i].subclass) {
              if (data[i].name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
                arr.push({
                  id: data[i].id,
                  value: data[i].name,
                })
              }
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (this.template.myTemplate) {
          f(this.template.myTemplate);
        }
        for (const item of results) {
          const findIndex = arr.findIndex(item1 => item.value === item1.value);
          if (findIndex === -1) {
            arr.push(item);
          }
        }
        cb(arr);
      },
      filterDisease(queryString) {
        return restaurant => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
          );
        };
      },
      selectedDisease(item) {
        this.selectedDiagnose = true;
        this.diagnoseResult = item.value;
        this.saveConclusion(true, item.id, "yes");
      },
      // 远程搜索
      async querySearch(queryString, cb) {
        let apolloRes = await this.$apollo.query({
          query: gql`
          query($keyword: String!) {
            patients(keyword: $keyword) {
              id
              name
              gender
              phone
              phone2
              address
              country
              id_card_number
              native_place
              profession
              email
              birthday
              id_in_hospital
              race
              skin_color
              skin_type
              age
              education
              smoking
              drinking
              diet_habit
              height
              weight
              note
              created_time
            }
          }
        `,
          variables: {
            keyword: queryString
          },
          fetchPolicy: "no-cache"
        });
        let restaurantsResponse = apolloRes.data.patients;
        const restaurants = restaurantsResponse;
        const results = queryString
          ? restaurants.filter(this.filterName(queryString))
          : restaurants;
        cb(results);
      },
      queryApplyDoctors(queryString, cb) {
        const restaurants = this.applyDoctors;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 5);
        cb(results);
      },
      queryApplyUnit(queryString, cb) {
        const restaurants = this.applyUnit;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 5);
        cb(results);
      },
      queryReviewDoctor(queryString, cb) {
        const restaurants = this.review_doctor_cache;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 5);
        cb(results);
      },
      queryCheckUnit(queryString, cb) {
        const restaurants = this.check_unit;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 5);
        cb(results);
      },
      queryFee(queryString, cb) {
        const restaurants = this.feeList;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 5);
        cb(results);
      },
      filterApply(queryString) {
        return restaurant => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0
          );
        };
      },
      filterName(queryString) {
        return restaurant => {
          return (
            restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          );
        };
      },
      selectedDoctor(item) {
        // console.log("选择的申请医生是：",item);
      },
      selectedApplyUnit(item) {
        // console.log("选择的申请单位是：",item);
      },
      selectedReviewDoctor(item) {
        // console.log("选择的审核医生是：",item);
      },
      selectedCheckUnit(item) {
        // console.log("选择的检查单位是：",item);
      },
      selectedCheckFee(item) {
        // console.log("选择的检查费用是：",item);
      },
      createFilter(queryString) {
        return restaurant => {
          return (
            restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          );
        };
      },
      // 处理选中状态选中之后的item统一在这里进行复制 queryString 远程查询结果在这里重新复制item form
      handleSelect(item) {
        // 重置form表单验证状态
        this.$refs.form.resetFields();
        
        this.isReset = true;
        this.readonly = true;
        this.fromNewDiagnose = true;
        this.form.name = item.name;
        this.form.created_time = item.created_time;
        this.form.age = item.age > -1 ? (item.age + '') : '';
        this.form.birthday = item.birthday === this.initialTime ? '' : moment(item.birthday).format('YYYY-MM-DD');
        this.form.id = item.id;
        this.form.id_in_hospital = item.id_in_hospital;
        this.form.gender = item.gender;
        this.form.skin_color = item.skin_color;
        this.form.skin_type = item.skin_type;
        this.form.race = item.race;
        this.form.phone = item.phone;
        this.patient_id = item.id;
        this.form.address = item.address;
        this.form.idCardNumber = item.id_card_number;
        this.form.nativePlace = item.native_place;
        this.form.country = item.country;
        this.form.profession = item.profession;
        this.form.email = item.email;
        this.form.phone2 = item.phone2 || '';
        this.form.education = item.education || '';
        this.form.smoking = item.smoking || '';
        this.form.drinking = item.drinking || '';
        this.form.dietHabitArr = item.diet_habit ? item.diet_habit.split(',').filter(s => s) : [];
        this.form.diet_habit = item.diet_habit || '';
        this.form.height = item.height || '';
        this.form.weight = item.weight || '';
        this.form.note = item.note || '';
        // 将最近一次填写检查信息填写上
        this.handleExamineInfo()
        // 请求历史诊断列表
        this.getHistoryCheckData();
        this.$message({
          type: "success",
          message: "患者已登记，请继续填写病历信息",
        });
      },
      showBigImg(num) {
        this.showBigList = true;
        this.$refs.mySwiper.swiper.slideTo(num, 1000, false);
      },
      swiperChange() {
        // console.log("swiper change");
      },
      closeBigList(event) {
        this.showBigList = false;
      },
      closeShowSuggestionTemplate() {
        this.isShowSuggestionTemplate = false;
      },
      closeAutoComplete() {
        this.$refs.collectionType.closeAutoComplete();
      },
      hiddentRemarkTemplate(){

        this.isShowRemarksTemplate = false;
      },
      hiddentSuggestTemplate(){
        this.isShowSuggestionTemplate = false;
      },
      
      // 显示存储空间使用情况提示
      showStorageRateMsg(){
          let accountInfo = this.$store.state.accountInfo;
          if(accountInfo.space_used && accountInfo.space_allocated){
            let usageRate = (accountInfo.space_used / accountInfo.space_allocated) * 100;
            if(usageRate >= 90){
              this.$message.error("存储空间即将用尽，请尽快联系管理员升级扩容！点击\"我的账户\"查看详情。");
            }
          }
      },

            
    },
    components: {
      DetailedResults,
      // PrintReport,
      swiper,
      swiperSlide,
      GeneralPlan,
      CollectionType,
      DiagnoseRecord,
      Tree,
      CompareImage,
      Lookimage,
      UpdateAnnouncement,
    }
  };
</script>
<style lang="less">
.history-tabel .el-table__body-wrapper{
  height: calc(100% - 48px);
  overflow-y: auto;
}
/*dialog关闭按钮样式*/
.intell-box .el-dialog__headerbtn{
  top: 10px;
  right: 22px;
  font-size: 24px;
}
.intell-box .el-icon-close::before{
  color: #61a2bf;
  font-weight: bold;
}
  #icon-close-1.el-icon-close::before{
    color: #ffffff;
  }
.intell-box_1 .resilts .el-icon-close::before{
  color: #ffffff;
  font-weight: bold;
}
</style>
<style lang="less" scoped>
  .patient-wrapper,
  .imgWrapper .chooseImgCon .sex-con,
  .race-con,
  .date-wrapper,
  .summary,
  .btns,
  .img-list-con,
  .img-list,
  .row-con,
  .img-item,
  .rightRadio,
  .line-sesu,
  .right-img-con,
  .CTetc-con,
  .top-nav,
  .left-row,
  .right-row,
  .bottom-wrapper,
  .head-con,
  .head-nav,
  .img-con,
  .report-con,
  .choosedFigureCon,
  .imgWrapper,
  .imgRes {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
  }
  
  .imgRes {
    width: 98%;
    height: 100%;
    flex-direction: column;
    align-items: flex-start;
    border: 1px solid #61a2bf;
    padding: 10px;
    font-size: 16px;
    color: #61a2bf;
    border-radius: 6px;
    margin-right: 1%;
    
    .imgResLine {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      
      .inline-input {
        ::-webkit-input-placeholder {
          text-align: center;
        }
      }
    }
  }
  
  /*::-webkit-scrollbar {*/
  /*width: 5px;*/
  /*height: 100%;*/
  /*}*/
  
  /*::-webkit-scrollbar-track-piece {*/
  /*background: #fff;*/
  /*-webkit-border-radius: 6px;*/
  /*}*/
  
  /*::-webkit-scrollbar-thumb:vertical {*/
  /*background-color: #61a2bf;*/
  /*-webkit-border-radius: 6px;*/
  /*}*/
  
  .similarDialog {
    .el-dialog--center {
      background: #ebebeb;
      border-radius: 10px;
    }
  }
  
  .imgWrapper {
    align-items: flex-start;
    justify-content: space-between;
    font-size: 1.5rem;
    margin-top: 5vh;
    color: #48a3c2;
    
    .chooseImgCon {
      flex: 1;
      text-align: center;
      margin-right: 2%;
      
      .cs-text {
        margin-bottom: 2vh;
      }
    }
    
    .chooseImgCon:nth-child(2) {
      margin-right: 0px;
    }
  }
  
  .race-con {
    margin-left: 19%;
    #input-box_1{
      display: flex;
    }
  }
  
  .choosedFigureCon {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    
    .choosedFigureItem {
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      // margin-right: 2rem;
      justify-content: space-between;
      width: 70%;
      background: #fff;
      text-align: center;
      padding: 2px 0px;
      padding-left: 10px;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
  
  .checkPositionCon {
    display: flex;
    align-items: center;
  }
  
  .topLevelCon {
    position: absolute;
    width: 50%;
    left: 15%;
    top: -15rem;
    // height: 300px;
    background: #fff;
    display: flex;
    z-index: 100;
    flex-direction: column;
    
    .topLevelItem {
      padding: 5px 1%;
      width: 100%;
      //height: 20px;
      position: relative;
      text-align: center;
      border-bottom: 1px solid #f2f2f2;
      font-size: 14px;
      border-right: 1px solid #f2f2f2;
      
      .secondLevelCon {
        position: absolute;
        width: 96%;
        //height: 186px;
        left: 100%;
        background: #fff;
        overflow-y: auto;
        border-left: 1px solid #f2f2f2;
        
        .secondLevelItem {
          width: 96%;
          padding: 5px 1%;
          //height: 20px;
          border-bottom: 1px solid #f2f2f2;
          border-left: 1px solid #f2f2f2;
          
          white-space: nowrap;
          cursor: pointer;
          font-size: 14px;
        }
      }
    }
  }
  
  .moreBtn {
    position: relative;
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    
    .moreButton {
      width: 20%;
      height: 20px;
      background: #61a2bf;
      color: #fff;
      cursor: pointer;
      padding: 5px 30px;
      line-height: 20px;
      border-radius: 5px;
      font-size: 15px;
      text-align: center;
    }
  }
  
  .addPatientBtn {
    width: 10%;
    display: flex;
    justify-content: center;
    height: 20px;
    background: #e9af3f;
    color: #fff;
    cursor: pointer;
    padding: 5px 10%;
    line-height: 20px;
    border-radius: 5px;
    font-size: 15px;
    text-align: center;
    white-space: nowrap;
  }
  
  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .camera-con {
    //original size
    // width: 52%;
    // left: 47%;
    // test size
    width: 64%;
    // 横向起始点从母Div左边left位置开始
    left: 34%;
    // 纵向起始点从母Div上边沿略微上移
    top: -12px;

    position: fixed;    
    border-radius: 15px;
    background: #ebebeb;
    outline: none;
    z-index: 2005;
    
    .booth {
      position: relative;
      
      .titleCon {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        margin-bottom: 0.6rem;
        margin-top: 1rem;
        
        .leftCon {
          display: flex;
          align-items: center;
          min-width: 118px;
          margin-left: 3%;
          color: #7cafc7;
          font-size: 1.2rem;
        }
        
        // .rightCon {
        //   /*margin-right: -40%;*/
        // }
      }
      
      #canvas {
        position: absolute;
        left: 3rem;
        top: 4rem;
      }
    }
  }
  
  .imgWrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
  }
  
  .chooseImgCon {
    flex-direction: column;
  }
  
  .imglist-con {
    width: 100%;
    height: 100%;
  }
  
  #div1 {
    border: 1px solid #ec0023;
    width: 100%;
    height: 200px;
  }
  
  .report-con {
    width: 100%;
    justify-content: space-between;
    margin-top: 30px;
  }
  
  .img-con {
    flex-wrap: wrap;
    width: 100%;
    
    .generalWrapper:nth-child(1) {
      margin-left: 1%;
    }
  }
  
  .CTetc-con {
    /*height: 67%;*/
     height: 73%;
  /*  height: calc(~"100% - 225px");*/
    min-height: 500px;
    flex-direction: column;
    
    .page-con {
      height: 89%;
    }
  }
  
  .row-con {
    width: 98%;
    height: 20%;
    min-height: 150px;
    margin: 0 1%;
    align-items: center;
    margin-bottom: 3%;
    .imgRes {
      height: 100%;
      padding: 1%;
      box-sizing: border-box;
      white-space: nowrap;
    }
  }
  .history-tabel {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 280px;
    .head{
      display: flex;
      align-items: center;
      height: 40px;
      color: rgb(97,162,191);
      margin: 0 10px;
      border-bottom: 2px solid rgb(97,162,191);
      box-sizing: border-box;
      .iconfont{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 35px;
        height: 35px;
        font-size: 26px;
      }
    }
  }
  
  .el-button {
    box-shadow: 3px 3px 10px grey;
  }
  
  .left-row {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border: 1px solid #48a3c2;
    border-radius: 10px;
    width: 50%;
    margin-right: 2%;
    height: 120px;
    align-items: flex-start;
    margin-left: 10px;
  }
  
  .right-row {
    width: 49%;
    height: 120px;
    align-items: flex-start;
    margin-right: 10px;
  }
  
  .img-list-con {
    width: 100%;
    justify-content: space-between;
  }
  
  .img-list {
    width: 90%;
  }
  
  .img-item {
    width: 25%;
    height: 94px;
    background: #f2f2f2;
    margin-right: 2%;
    box-shadow: 1px 1px 10px grey;
  }
  
  textarea::-webkit-input-placeholder {
    color: #61a2bf;
    font-size: 15px;
  }
  
  // .img-item:nth-child(1) {
  // }
  
  .img-item:nth-child(3) {
    margin-right: 0%;
  }
  
  .activeOption {
    color: #48a3c2;
    border: 1px solid #48a3c2;
    background: #f2f2f2;
  }
  
  .normalOption {
    background: #f2f2f2;
  }
  
  textarea {
    outline: none;
  }
  
  .summary {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 120px;
    border-top: 1px solid #48a3c2;
    width: 98%;
    margin-top: 10px;
  }
  
  .rightRadio {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 12%;
  }
  
  .top-nav {
    flex-direction: row;
    justify-content: space-around;
    // flex-shrink: 2;
    width: 100%;
    /*height: 8.6%;*/
    height: 40px;
    display: flex;
    
    .option-item {
      background: #dcdcdc;
      // width: 19.7%;
      flex: 1;
      height: 100%;
      font-size: 16px;
      text-align: center;
      box-shadow: 2px 2px 10px grey;
      white-space: nowrap;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    .option-item:nth-child(3) {
      margin-bottom: 0px;
    }
  }
  
  .right-img-con {
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    height: 300px;
    margin-left: -1.1%;
    margin-top: -5px;
    padding: 5px 5px;
    overflow-y: auto;
  }
  
  .line-sesu {
    margin-left: 4%;
  }
  
  .btns {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    
    .markAndGenerate {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      margin-left: 13px;
      height: 100%;
      
      .collectBtn {
        height: 100%;
        cursor: pointer;
        display: flex;
        width: 92px;
        flex-direction: column;
        // height: 32px;
        line-height: 32px;
        justify-content: center;
        align-items: center;
        color: #fff;
        border-radius: 5px;
        
        .btn-btn{
          height: 28px;
        }
        .print-btn{
          flex: 1;
          margin-bottom: 4px;
        }
        .download-btn{
          margin-bottom: 4px;
          flex: 1;
        }
      }
    }
  }
  
  .date-wrapper {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  .sex-con {
    display: flex;
    align-items: center;
    margin-right: 3%;
  }
  
  .label {
    font-size: 14px;
    color: #606266;
    margin-right: 6%;
    white-space: nowrap;
  }
  
  // .more-wrapper {
  // }
  
  .right-img-con {
    background: #f2f2f2;
  }
  
  p {
    margin: 0;
  }
  
  .intell-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
  }
  
  .i-header,
  .c-header {
    width: 92%;
    color: #48a3c2;
    font-size: 16px;
    border-bottom: 2px solid #48a3c2;
    padding: 5px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    height: 25px;
    text-align: left;
    display: flex;
    align-items: center;
  }
  
  .patient-header {
    display: flex;
    justify-content: space-between;
  }
  
  .c-content {
    padding-right: 7%;
    text-align: right;
    // overflow-x: hidden;
    // overflow-y: hidden;
    height: 50%;
  }
  
  // @media screen and(min-width: 1920px) {
  //   .intell-box{
  //     .intell-right{
  //       width: 80%;
  //     }
  //   }
  // }
  .intell-left {
    width: 330px;
    min-width: 300px;
    height: 100%;
    background: #eff3f7;
    float: left;
    padding: 5px 0px;
    padding-left: 6px;
    overflow: hidden;
    // overflow-y: auto;
    .el-dialog__title {
      color: #4da3c0 !important;
      font-size: 20px;
      font-weight: 600;
    }
    .el-dialog__close {
      color: #4da3c0 !important;
      font-size: 26px;
      font-weight: 700;
    }
    .el-dialog__body {
      padding: 0 20px 30px;
    }
    .el-dialog {
      margin-top: 0 !important;
    }
  }
  
  .intell-right {
    overflow-y: hidden;
    padding-right: 1px;
    min-width: 850px;
    height: 100%;
    float: left;
    display: flex;
    flex: 1;
    flex-direction: row;
    margin-left: 4px;
    
    .left-content {
      width: 100%;
      height: 100%;
    }
  }
  
  .right-knowledge {
    position: relative;
    background: #eff3f7;
    width: 302px;
    min-width: 253px;
    overflow-y: auto;
    margin-left: 4px;
    
    .detailed-l {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 280px;
      padding: 1%;
      
      .tree-content {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 46px;
        padding-left: 7%;
        padding-right: 7%;
      }
      
      .detailed-head {
        color: #61a2bf;
        width: 100%;
        padding-left: 7%;
        padding-bottom: 6px;
        box-sizing: border-box;
        border-bottom: 2px solid #61a2bf;
        display: flex;
        align-items: center;
      }
    }
  }
  
  .patient-info {
    width: 100%;
    overflow: hidden;
  }

  .patient-max-btn {
    cursor: pointer;
    font-size: 18px;
    color: #4da2be;
    margin-left: 5px;
    vertical-align: middle;
  }
  .patient-max-btn:hover {
    color: #66b1ff;
  }

  .patient-max-dialog {
    .el-dialog__body {
      padding: 10px 20px 20px;
      max-height: 80vh;
      overflow-y: auto;
    }
  }
  .patient-max-form {
    /deep/ .el-form-item__label {
      font-size: 17px;
    }
    /deep/ .el-input__inner {
      font-size: 17px;
    }
    /deep/ .el-radio-button__inner {
      font-size: 17px;
    }
    .field-filled {
      /deep/ .el-input, /deep/ .el-textarea {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 4px;
          right: 4px;
          width: 8px;
          height: 8px;
          background: #4da2be;
          border-radius: 50%;
          z-index: 1;
          pointer-events: none;
        }
      }
    }
  }

  .check-max-btn {
    cursor: pointer;
    font-size: 18px;
    color: #4da2be;
    margin-left: 5px;
    vertical-align: middle;
  }
  .check-max-btn:hover {
    color: #66b1ff;
  }

  .check-max-dialog {
    overflow: hidden !important;
    .el-dialog {
      // margin-top: 8vh !important;
      max-height: 88vh;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .el-dialog__header {
      flex-shrink: 0;
    }
    .el-dialog__body {
      padding: 10px 20px 20px;
      max-height: 80vh;
      overflow-y: auto;
      flex: 1;
      // min-height: 0;
    }
  }
  .check-max-form {
    /deep/ .el-form-item__label {
      font-size: 17px;
    }
    /deep/ .el-input__inner {
      font-size: 17px;
    }
    /deep/ .el-textarea__inner {
      font-size: 17px;
    }
    .field-filled {
      /deep/ .el-input, /deep/ .el-textarea {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 4px;
          right: 4px;
          width: 8px;
          height: 8px;
          background: #4da2be;
          border-radius: 50%;
          z-index: 1;
          pointer-events: none;
        }
      }
    }
  }
  .check-max-top-level {
    z-index: 3001 !important;
  }

  .check-info {
    width: 100%;
    padding-bottom: 30px;
  }
  
  .intell-r-t,
  .intell-r-c,
  .intell-r-b {
    overflow: hidden;
  }
  
  .intell-r-t {
    width: 100%;
    height: 100%;
  }
  
  .text-header {
    margin-top: 5px;
    margin-left: 5px;
  }
  
  .intell-r-c {
    height: 56%;
    width: 100%;
    overflow: hidden;
  }
  
  .btn-wrapper,
  .i-header,
  .p-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }
  
  .i-header {
    /*height: 2.8%;*/
    height: 3%;
    font-size: 17px;
  }
  
  .p-header {
    justify-content: flex-start;
  }
  
  .btn-wrapper {
    justify-content: space-around;
  }
  
  .img-l {
    width: 100%;
    height: 100%;
    float: left;
    box-sizing: border-box;
    position: relative;
    text-align: center;
  }
  
  .upload {
    position: absolute;
    bottom: 10px;
    right: 70px;
    z-index: 999;
  }
  
  .img-r {
    width: 60%;
    float: left;
    height: 100%;
  }
  
  .img-btn {
    float: right;
  }
  
  .img-list {
    width: 93%;
    height: 270px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  
  .img-list .img-box {
    width: 122px;
    height: 92px;
    margin: 5px;
    float: left;
  }
  
  .img-box img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  
  .img-box {
    position: relative;
  }
  
  .img-box2 {
    width: 100px;
    height: 86px;
    position: relative;
    margin: 5px;
    float: left;
    background-color: black;
  }
  
  .mirror-type {
    width: 50px;
    height: 15px;
    text-align: center;
    background: #fff;
    z-index: 100;
    position: absolute;
    bottom: 1px;
    left: 1px;
    border-radius: 5px;
    color: #48a3c2;
    font-size: 12px;
  }
  
  .edit-btn2 {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    line-height: 86px;
    text-align: center;
  }
  
  .edit-btn {
    width: 80x;
    height: 20px;
    position: absolute;
    top: 0;
    right: 0;
    line-height: 20px;
    text-align: center;
  }
  
  .mycanvas {
    display: none;
  }
  
  .diagnosis-info {
    width: 630px;
    height: 86%;
    border: 1px solid #48a3c2;
    border-radius: 10px;
    float: left;
    margin-right: 10px;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .detailed-info {
    width: 303px;
    height: 100%;
    float: left;
  }
  
  .detailed-top {
    width: 100%;
    height: 100%;
    border: 1px solid #48a3c2;
    border-radius: 10px;
    margin-bottom: 3px;
    padding: 10px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  
  .detailed-bottom {
    width: 100%;
    height: 77.5px;
    border: 1px solid #48a3c2;
    border-radius: 10px;
  }
  
  .report-img {
    width: 90%;
    height: 28%;
    border: 1px solid #48a3c2;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 10px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  
  .report-img img {
    width: 100px;
    height: 80px;
    margin: 5px;
  }
  
  .report-img p {
    margin: 0;
  }
  
  .img-desc {
    width: 90%;
    height: 28%;
    border: 1px solid #48a3c2;
    border-radius: 10px;
    margin-right: 10px;
    padding: 10px;
    overflow: hidden;
  }
  
  .img-desc textarea {
    border: none;
    outline: none;
    resize: none;
  }
  
  .img-desc textarea:focus {
    border: none;
  }
  
  .img-desc p {
    margin: 0;
  }
  
  .intell-btn {
    width: 100%;
    height: 150px;
  }
  
  .intell-btn button {
    width: 90px;
    margin: 10px 5px;
  }
  
  // .editorImg-enter-active,
  // .fade-leave-active {
  // }
  
  .editorImg-enter,
  .editorImg-leave-to {
    opacity: 1;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  
  .edit-container {
    z-index: 999;
  }
  
  .edit-box {
    background: #ebebeb;
    border-radius: 20px;
    width: 72vw;
    height: 86vh;
    position: fixed;
    top: 6vh;
    left: 13vw;
    z-index: 999;
    padding: 20px;
    // padding-top: 50px;
    box-sizing: border-box;
  }
  
  .resilts {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  
  .print-content {
    width: 100%;
    height: 100%;
    z-index: 999;
    position: fixed;
    // display: none;
    overflow-y: auto;
    top: 0;
    left: 0;
  }
  
  .detailed-bottom {
    padding: 10px;
    text-align: center;
    box-sizing: border-box;
  }
  
  .el-form-item {
    margin-bottom: 10px;
  }
  
  .result-img {
    width: 86px;
    height: 65px;
    float: left;
    margin: 5px 1px;
  }
  
  .result-img img {
    width: 100%;
    height: 100%;
  }
  
  .el-autocomplete-suggestion li.highlighted,
  .el-autocomplete-suggestion li:hover {
    background-color: #116cf5;
  }
  
  .big-img {
    width: 50%;
    height: 80%;
    margin-top: 5%;
    margin: 0 auto;
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    border: 1px solid #000;
    box-sizing: border-box;
    position: fixed;
    top: 5%;
    left: 25%;
    z-index: 999;
  }
  
  .big-img h1 {
    font-size: 24px;
    text-align: center;
    margin: 10px 0;
    position: relative;
  }
  
  .big-img h1 i {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 10px;
  }
  
  .big-img-content {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  
  .myswiper-pagination {
    text-align: center;
  }
  
  .myswiper-pagination span {
    margin: 0 10px;
  }
  
  @media screen and (max-width: 1366px) {
    .intell-box {
      .intell-left {
        min-width: 320px;
        width: 320px;
      }
      
      .intell-right {
        min-width: 683px;
      }
      
      .right-knowledge {
        min-width: 260px;
        width: 260px;
      }
    }
  }
  
  .el-dialog--center .el-dialog__body {
    padding: 0 !important;
  }
  
  .el-dialog__body {
    padding: 0 !important;
  }
  
  .intell-left-content {
    height: calc(~"100% - 42px") !important;
    overflow: auto !important;
  }
  
  .show-more-text{
    color: rgb(97,162,191);
    font-size: 17px;
    font-weight: bold;
    cursor: pointer
  }
  .show-more-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(97,162,191);
    font-size: 19px;
    cursor: pointer;
  }
  
  .video-flash{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }
  
  .bigImage{
    position: relative;
    .next-btn{
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      right: 0;
      width: 80px;
      height: 100%;
      color: #ccc;
      background-color: rgba(255, 255, 255, .1);
      cursor: pointer;
      font-size: 30px;
      font-weight: bolder;
    }
    .previous-btn{
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 100%;
      color: #ccc;
      background-color: rgba(255, 255, 255, .1);
      cursor: pointer;
      font-size: 30px;
      font-weight: bolder;
    }
    .next-btn:active{
      background-color: rgba(255, 255, 255, .2);
    }
    .previous-btn:active{
      background-color: rgba(255, 255, 255, .2);
    }
  }

  .save-btn {
    font-size: 28px;
    user-select: none;
    cursor: pointer;
    margin-left: 10px;
  }

  .autoComplate {
    position: absolute;
    left: -1px;
    top: -132px;
    width: 98%;
    height: 124px;
    background-color: #eff3f7;
    padding: 5px;
    border: 1px solid #48a3c2;
    border-radius: 10px;
    z-index: 2;
  
    .item {
      position: relative;
      display: flex;
      align-items: center;
      color: #111;
      text-align: left;
      cursor: default;
      font-size: 14px;
      .item-text{
        flex: 1;
        padding: 5px 0;
      }
      .delete-box{
        display: none;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0;
        top: 1px;
        width: 24px;
        height: 100%;
        .delete-ben{
          display: flex;
          justify-content: center;
          align-items: center;
          color: rgb(97,162,191);
          background-color: #eee;
          border-radius: 50%;
          cursor: pointer;
          font-size: 24px;
        }
      }
    }
  
    .item + .item {
      border-top: 1px solid #eee;
    }
  
    .item:hover {
      background-color: #eee;
    }
    .item:hover .delete-box{
      display: flex;
    }
  }

  .dialog{
    .navBorder {
      width: 100%;
      height: 2px;
      background: #4da3c0;
      margin-top: -16px;
      margin-bottom: 16px;
    }
  }
</style>


